(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clean-hg-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const cleanFormatCartMoney = (cents, moneyFormat) => {
      const amount = (Number(cents || 0) / 100).toFixed(2);
      const placeholderPattern = (name) => new RegExp(['\\{', `\\{\\s*${name}\\s*\\}\\}`].join(''), 'g');
      const format = moneyFormat || `₹${['{', '{ amount }}'].join('')}`;

      return format
        .replace(placeholderPattern('amount_with_comma_separator'), amount.replace('.', ','))
        .replace(placeholderPattern('amount_no_decimals'), amount.replace(/\.\d+$/, ''))
        .replace(placeholderPattern('amount'), amount)
        .replace(/<[^>]*>/g, '')
        .replace(/\b(?:Rs\.?|INR)[\s\u00a0]*/gi, '₹');
    };

    const escapeCleanCartHtml = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const cleanCartMoneyAttributes = (cents, drawer) => {
      const sourceText = cleanFormatCartMoney(cents, drawer.dataset.cleanCartMoneyFormat);
      const sourceCurrency =
        drawer.dataset.cleanCartSourceCurrency ||
        document.querySelector('[data-clean-display-currency-config]')?.dataset.cleanDisplayCurrencySource ||
        '';

      return `data-clean-money data-clean-money-minor="${escapeCleanCartHtml(
        cents,
      )}" data-clean-money-currency="${escapeCleanCartHtml(
        sourceCurrency,
      )}" data-clean-money-source-text="${escapeCleanCartHtml(
        sourceText,
      )}" data-money-cents="${escapeCleanCartHtml(cents)}" data-inr-display="${escapeCleanCartHtml(sourceText)}"`;
    };

    const cleanCartAjaxUrl = (url, fallback) => {
      const rawUrl = url || fallback;

      try {
        const parsedUrl = new URL(rawUrl, window.location.origin);
        const path = parsedUrl.pathname.replace(/\/$/, '');
        parsedUrl.pathname = path.endsWith('.js') ? path : `${path}.js`;
        parsedUrl.search = '';

        return `${parsedUrl.pathname}${parsedUrl.search}`;
      } catch (error) {
        const path = String(rawUrl || fallback || '').replace(/\/$/, '');
        return path.endsWith('.js') ? path : `${path}.js`;
      }
    };

    const cleanCartRequest = (url, options = {}) =>
      fetch(url, {
        credentials: 'same-origin',
        ...options,
        headers: {
          Accept: 'application/json',
          'X-Clean-Cart': 'true',
          ...(options.headers || {}),
        },
      });

    const getCleanCartStateCoordinator = () => {
      if (window.CleanCartState?.refresh && window.CleanCartState?.publish) return window.CleanCartState;

      const state = {
        cart: window.cart || null,
        inFlight: null,
        lastUpdatedAt: window.cart ? Date.now() : 0,
      };
      const publish = (cart) => {
        if (!cart || !Array.isArray(cart.items)) return cart;
        state.cart = cart;
        state.lastUpdatedAt = Date.now();
        return cart;
      };
      const readCart = async () => {
        const drawer = getCleanCartDrawer();
        if (!drawer) return null;
        const response = await cleanCartRequest(getCleanCartJsonUrl(drawer));
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      };
      const refresh = (loader = readCart) => {
        if (state.inFlight) return state.inFlight;

        state.inFlight = Promise.resolve()
          .then(loader)
          .then(publish)
          .finally(() => {
            state.inFlight = null;
          });

        return state.inFlight;
      };

      window.CleanCartState = { publish, refresh, state };
      return window.CleanCartState;
    };

    const cleanClampCartQuantity = (value) => {
      const quantity = Number.parseInt(value, 10);
      return Number.isFinite(quantity) ? Math.max(0, quantity) : 0;
    };

    const getCleanCartImageUrl = (source, width = 140) => {
      if (!source) return '';

      try {
        const imageUrl = new URL(source, window.location.origin);
        const hostname = imageUrl.hostname.toLowerCase();
        const isShopifyImage =
          hostname === window.location.hostname.toLowerCase() ||
          hostname === 'cdn.shopify.com' ||
          hostname.endsWith('.myshopify.com') ||
          hostname.endsWith('.shopifycdn.com');

        if (isShopifyImage) imageUrl.searchParams.set('width', String(width));
        return imageUrl.toString();
      } catch (error) {
        return String(source);
      }
    };

    const cleanCartProductCache = new Map();
    const cleanCartPendingCompareHydrations = new WeakMap();
    const cleanCartCompareHydrationConcurrency = 3;
    let cleanCartRenderSequence = 0;
    let cleanCartLastTrackedAddAt = 0;
    let cleanCartTrackedAddPromise = null;

    const cleanNormalizeCartPrice = (value) => {
      const price = Number(value);
      return Number.isFinite(price) ? price : 0;
    };

    const hasCleanCartDiscount = (item = {}) => {
      if (cleanNormalizeCartPrice(item.total_discount) > 0) return true;
      return (item.discount_allocations || item.line_level_discount_allocations || []).some(
        (allocation) => cleanNormalizeCartPrice(allocation?.amount) > 0,
      );
    };

    const getCleanCartLinePrice = (item) => {
      const finalLinePrice = cleanNormalizeCartPrice(item?.final_line_price);
      if (finalLinePrice > 0) return finalLinePrice;

      const linePrice = cleanNormalizeCartPrice(item?.line_price);
      if (linePrice > 0) return linePrice;

      const unitPrice = cleanNormalizeCartPrice(item?.final_price || item?.price);
      if (unitPrice > 0) return unitPrice * cleanClampCartQuantity(item?.quantity || 1);

      const originalLinePrice = cleanNormalizeCartPrice(item?.original_line_price);
      if (!hasCleanCartDiscount(item) && originalLinePrice > 0) return originalLinePrice;

      return 0;
    };

    const hasCleanCartUnexpectedZeroPrice = (item = {}) =>
      cleanClampCartQuantity(item.quantity) > 0 && getCleanCartLinePrice(item) === 0 && !hasCleanCartDiscount(item);

    const getCleanCartDirectCompareUnitPrice = (item) => {
      const candidates = [
        item?.variant_compare_at_price,
        item?.compare_at_price,
        item?.variant?.compare_at_price,
        item?.original_price,
      ];

      return candidates.map(cleanNormalizeCartPrice).find((price) => price > 0) || 0;
    };

    const hasCleanCartDirectCompareAtPrice = (item) =>
      [item?.variant_compare_at_price, item?.compare_at_price, item?.variant?.compare_at_price]
        .map(cleanNormalizeCartPrice)
        .some((price) => price > 0);

    const getCleanCartCompareAtUnitPrice = (item) =>
      [item?.variant_compare_at_price, item?.compare_at_price, item?.variant?.compare_at_price]
        .map(cleanNormalizeCartPrice)
        .find((price) => price > 0) || 0;

    const getCleanCartCompareLinePrice = (item, compareUnitPrice = getCleanCartDirectCompareUnitPrice(item)) => {
      const quantity = cleanClampCartQuantity(item?.quantity || 1) || 1;
      const linePrice = getCleanCartLinePrice(item);
      const directCompareLinePrice = compareUnitPrice * quantity;
      const originalLinePrice = cleanNormalizeCartPrice(item?.original_line_price);

      if (directCompareLinePrice > linePrice) return directCompareLinePrice;
      if (originalLinePrice > linePrice) return originalLinePrice;
      return 0;
    };

    const getCleanCartDiscountPercent = (compareLinePrice, linePrice) => {
      if (!compareLinePrice || compareLinePrice <= linePrice) return 0;
      return Math.round(((compareLinePrice - linePrice) * 100) / compareLinePrice);
    };

    const renderCleanCartPriceHtml = (item, drawer, compareLinePrice = getCleanCartCompareLinePrice(item)) => {
      const linePrice = getCleanCartLinePrice(item);
      const discountPercent = getCleanCartDiscountPercent(compareLinePrice, linePrice);
      const comparePrice = compareLinePrice
        ? `<s class="clean-cart-drawer__compare-price" ${cleanCartMoneyAttributes(
            compareLinePrice,
            drawer,
          )}>${escapeCleanCartHtml(cleanFormatCartMoney(compareLinePrice, drawer.dataset.cleanCartMoneyFormat))}</s>`
        : '';
      const discount = discountPercent
        ? `<span class="clean-cart-drawer__discount">${discountPercent}% off</span>`
        : '';

      return `
        ${comparePrice}
        <span class="clean-cart-drawer__price" ${cleanCartMoneyAttributes(
          linePrice,
          drawer,
        )}>${escapeCleanCartHtml(cleanFormatCartMoney(linePrice, drawer.dataset.cleanCartMoneyFormat))}</span>
        ${discount}
      `;
    };

    const getCleanCartItemKey = (item) => String(item?.key || item?.id || item?.variant_id || '').trim();

    const getCleanCartCompareAtLinePrice = (item, compareUnitPrice = getCleanCartCompareAtUnitPrice(item)) => {
      const quantity = cleanClampCartQuantity(item?.quantity || 1) || 1;
      const linePrice = getCleanCartLinePrice(item);
      const compareLinePrice = compareUnitPrice * quantity;
      return compareLinePrice > linePrice ? compareLinePrice : 0;
    };

    const getCleanCartHydratedCompareLinePrice = (item, compareLinePrices) => {
      const directCompareLinePrice = getCleanCartCompareAtLinePrice(item);
      if (directCompareLinePrice) return directCompareLinePrice;

      if (!compareLinePrices) return 0;
      return cleanNormalizeCartPrice(compareLinePrices.get(getCleanCartItemKey(item)));
    };

    const cleanCartDefaultFreeShippingThreshold = 49900;
    const cleanCartStandardShippingCharge = 9000;
    const cleanCartRewardMilestones = [
      { amount: 200000, discount: 10000 },
      { amount: 500000, discount: 25000 },
      { amount: 750000, discount: 35000 },
      { amount: 1000000, discount: 50000 },
    ];
    const cleanCartRewardMaximum = cleanCartRewardMilestones[cleanCartRewardMilestones.length - 1].amount;

    const getCleanCartFreeShippingThreshold = (drawer) => {
      const configuredThreshold = cleanNormalizeCartPrice(drawer?.dataset.cleanCartFreeShippingThreshold);
      return configuredThreshold || cleanCartDefaultFreeShippingThreshold;
    };

    const getCleanCartRewardState = (cartTotal) => {
      const nextMilestone = cleanCartRewardMilestones.find((milestone) => cartTotal < milestone.amount) || null;

      return {
        nextMilestone,
        remainingToNextMilestone: nextMilestone
          ? Math.max(100, Math.ceil((nextMilestone.amount - cartTotal) / 100) * 100)
          : 0,
        progress: Math.min(100, Math.max(0, (cartTotal * 100) / cleanCartRewardMaximum)),
      };
    };

    const getCleanCartTotalsBreakdown = (cart, compareLinePrices, drawer) => {
      const items = cart?.items || [];
      const lineSubtotal = items.reduce((total, item) => total + getCleanCartLinePrice(item), 0);
      const shopifyCartTotal = cleanNormalizeCartPrice(cart?.total_price);
      const cartTotal = shopifyCartTotal || lineSubtotal;
      const freeShippingThreshold = getCleanCartFreeShippingThreshold(drawer);
      const hasFreeShipping = cartTotal >= freeShippingThreshold;
      const shippingCharge = cartTotal > 0 && !hasFreeShipping ? cleanCartStandardShippingCharge : 0;
      const shippingSavings = hasFreeShipping ? cleanCartStandardShippingCharge : 0;
      const freeShippingAmountRemaining = shippingCharge
        ? Math.max(100, Math.ceil((freeShippingThreshold - cartTotal) / 100) * 100)
        : 0;
      const estimatedTotal = cartTotal + shippingCharge;
      let mrpTotal = 0;
      let hasCompareSavings = false;

      items.forEach((item) => {
        const linePrice = getCleanCartLinePrice(item);
        const compareLinePrice = getCleanCartHydratedCompareLinePrice(item, compareLinePrices);

        if (compareLinePrice > linePrice) {
          mrpTotal += compareLinePrice;
          hasCompareSavings = true;
          return;
        }

        mrpTotal += linePrice;
      });

      const savings = hasCompareSavings ? Math.max(0, mrpTotal - cartTotal) : 0;
      const totalSavings = savings + shippingSavings;
      const estimatedCompareTotal = mrpTotal + (items.length ? cleanCartStandardShippingCharge : 0);
      const discountPercent = totalSavings ? getCleanCartDiscountPercent(estimatedCompareTotal, estimatedTotal) : 0;

      return {
        cartTotal,
        discountPercent,
        estimatedCompareTotal,
        estimatedTotal,
        freeShippingAmountRemaining,
        freeShippingThreshold,
        hasFreeShipping,
        hasItems: items.length > 0,
        hasSavings: totalSavings > 0,
        mrpTotal,
        savings,
        shippingCharge,
        shippingSavings,
        totalSavings,
      };
    };

    const refreshCleanCartCurrency = (element) => {
      window.CleanDisplayCurrency?.refresh?.(element);
      window.HadiyahDisplayCurrency?.refresh?.(element);
    };

    const setCleanCartMoneyText = (target, value, drawer, { prefix = '', suffix = '' } = {}) => {
      if (!target) return;

      const sourceText = cleanFormatCartMoney(value, drawer.dataset.cleanCartMoneyFormat);

      if (!prefix && !suffix) {
        target.dataset.cleanMoney = '';
        target.dataset.cleanMoneyMinor = String(value);
        target.dataset.cleanMoneyCurrency = drawer.dataset.cleanCartSourceCurrency || '';
        target.dataset.cleanMoneySourceText = sourceText;
        target.dataset.moneyCents = String(value);
        target.dataset.inrDisplay = sourceText;
        target.textContent = sourceText;
        refreshCleanCartCurrency(target);
        return;
      }

      target.removeAttribute('data-clean-money');
      target.removeAttribute('data-clean-money-minor');
      target.removeAttribute('data-clean-money-currency');
      target.removeAttribute('data-clean-money-source-text');
      target.removeAttribute('data-clean-money-display-currency');
      target.removeAttribute('data-money-cents');
      target.removeAttribute('data-inr-amount');
      target.removeAttribute('data-inr-display');
      target.removeAttribute('data-display-currency-converted');
      target.removeAttribute('title');
      target.removeAttribute('aria-label');
      const money = document.createElement('span');
      money.dataset.cleanMoney = '';
      money.dataset.cleanMoneyMinor = String(value);
      money.dataset.cleanMoneyCurrency = drawer.dataset.cleanCartSourceCurrency || '';
      money.dataset.cleanMoneySourceText = sourceText;
      money.dataset.moneyCents = String(value);
      money.dataset.inrDisplay = sourceText;
      money.textContent = sourceText;
      target.replaceChildren(document.createTextNode(prefix), money, document.createTextNode(suffix));
      refreshCleanCartCurrency(money);
    };

    const setCleanCartCompactMoneyText = (target, value, { abbreviateThousands = false } = {}) => {
      if (!target) return;

      const rupees = Math.max(0, Number(value) || 0) / 100;
      const amount =
        abbreviateThousands && rupees >= 1000
          ? `${Number.isInteger(rupees / 1000) ? rupees / 1000 : (rupees / 1000).toFixed(1)}k`
          : Math.round(rupees).toLocaleString('en-IN');
      const sourceText = `₹${amount}`;

      target.dataset.cleanMoney = '';
      target.dataset.cleanMoneyMinor = String(value);
      target.dataset.cleanMoneyCurrency = 'INR';
      target.dataset.cleanMoneySourceText = sourceText;
      target.dataset.moneyCents = String(value);
      target.dataset.inrDisplay = sourceText;
      target.textContent = sourceText;
      refreshCleanCartCurrency(target);
    };

    const setCleanCartMoneyParts = (target, parts, drawer) => {
      if (!target) return;

      const moneyBindings = [];
      const nodes = parts.map((part) => {
        if (typeof part === 'string') return document.createTextNode(part);

        const money = document.createElement('span');
        moneyBindings.push([money, part.money]);
        return money;
      });

      target.replaceChildren(...nodes);
      moneyBindings.forEach(([money, value]) => setCleanCartMoneyText(money, value, drawer));
    };

    const updateCleanCartRewardCelebration = (drawer, rewardsComplete) => {
      const panel = drawer?.querySelector('[data-clean-cart-shipping-progress-panel]');
      const detail = drawer?.querySelector('[data-clean-cart-reward-detail]');
      if (!drawer || !panel) return;

      panel.classList.toggle('clean-cart-drawer__shipping-progress-panel--complete', rewardsComplete);
      detail?.classList.toggle('clean-cart-drawer__reward-detail--complete', rewardsComplete);

      if (!rewardsComplete) {
        panel.classList.remove('clean-cart-drawer__shipping-progress-panel--celebrating');
        drawer.cleanCartRewardsWereComplete = false;
        return;
      }

      if (drawer.cleanCartRewardsWereComplete) return;
      drawer.cleanCartRewardsWereComplete = true;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      panel.classList.remove('clean-cart-drawer__shipping-progress-panel--celebrating');
      void panel.offsetWidth;
      panel.classList.add('clean-cart-drawer__shipping-progress-panel--celebrating');
      window.clearTimeout(drawer.cleanCartRewardCelebrationTimer);
      drawer.cleanCartRewardCelebrationTimer = window.setTimeout(() => {
        panel.classList.remove('clean-cart-drawer__shipping-progress-panel--celebrating');
      }, 1600);
    };

    const renderCleanCartTotals = (drawer, cart, compareLinePrices) => {
      const totalTarget = drawer?.querySelector('[data-clean-cart-drawer-total]');
      const compareTarget = drawer?.querySelector('[data-clean-cart-total-compare]');
      const discountTarget = drawer?.querySelector('[data-clean-cart-total-discount]');
      const toggle = drawer?.querySelector('[data-clean-cart-summary-toggle]');
      const summary = drawer?.querySelector('[data-clean-cart-summary]');
      if (!drawer || !totalTarget) return;

      const breakdown = getCleanCartTotalsBreakdown(cart, compareLinePrices, drawer);
      const rewardState = getCleanCartRewardState(breakdown.cartTotal);
      setCleanCartMoneyText(totalTarget, breakdown.estimatedTotal, drawer);

      if (compareTarget) {
        compareTarget.hidden = !breakdown.hasSavings;
        if (breakdown.hasSavings) {
          setCleanCartMoneyText(compareTarget, breakdown.estimatedCompareTotal, drawer);
        }
      }

      if (discountTarget) {
        discountTarget.hidden = !breakdown.hasSavings || !breakdown.discountPercent;
        discountTarget.textContent = breakdown.discountPercent ? `(${breakdown.discountPercent}% OFF)` : '';
      }

      if (toggle) {
        toggle.hidden = !breakdown.hasItems;
        if (!breakdown.hasItems) toggle.setAttribute('aria-expanded', 'false');
      }

      if (summary) {
        const shouldShowSummary = breakdown.hasItems && toggle?.getAttribute('aria-expanded') === 'true';
        summary.hidden = !shouldShowSummary;
      }

      drawer.querySelectorAll('[data-clean-cart-summary-saved]').forEach((target) => {
        target.hidden = !breakdown.hasSavings;
        if (breakdown.hasSavings) {
          setCleanCartMoneyText(target, breakdown.totalSavings, drawer, { suffix: ' saved so far' });
        } else {
          target.replaceChildren();
        }
      });
      drawer.querySelectorAll('[data-clean-cart-shipping-progress-panel]').forEach((target) => {
        const shouldShowProgress = breakdown.hasItems;
        const progressTarget = target.querySelector('[data-clean-cart-shipping-progress]');
        const progressFill = target.querySelector('[data-clean-cart-shipping-progress-fill]');
        const progressTruck = target.querySelector('[data-clean-cart-shipping-progress-truck]');
        const nextMarkerAmount = breakdown.hasFreeShipping
          ? rewardState.nextMilestone?.amount
          : breakdown.freeShippingThreshold;

        target.hidden = !shouldShowProgress;
        target.dataset.cleanCartShippingProgress = String(rewardState.progress);
        if (progressTarget) progressTarget.setAttribute('aria-valuenow', String(Math.round(rewardState.progress)));
        if (progressFill) progressFill.style.width = `${rewardState.progress}%`;
        if (progressTruck) progressTruck.style.left = `${rewardState.progress}%`;

        target.querySelectorAll('[data-clean-cart-reward-marker]').forEach((marker) => {
          const isShippingMarker = marker.dataset.cleanCartRewardMarkerAmount === 'shipping';
          const markerAmount = isShippingMarker
            ? breakdown.freeShippingThreshold
            : cleanNormalizeCartPrice(marker.dataset.cleanCartRewardMarkerAmount);
          const markerPosition = Math.min(100, Math.max(0, (markerAmount * 100) / cleanCartRewardMaximum));
          const unlocked = breakdown.cartTotal >= markerAmount;

          if (isShippingMarker) marker.style.left = `${markerPosition}%`;
          marker.classList.toggle('clean-cart-drawer__reward-marker--unlocked', unlocked);
          marker.classList.toggle(
            'clean-cart-drawer__reward-marker--next',
            !unlocked && markerAmount === nextMarkerAmount,
          );
        });

        target.querySelectorAll('[data-clean-cart-reward-marker-discount]').forEach((label) => {
          setCleanCartCompactMoneyText(label, label.dataset.cleanCartRewardMarkerDiscount);
        });
        target.querySelectorAll('[data-clean-cart-reward-marker-spend]').forEach((label) => {
          setCleanCartCompactMoneyText(label, label.dataset.cleanCartRewardMarkerSpend, {
            abbreviateThousands: true,
          });
        });
      });
      drawer.querySelectorAll('[data-clean-cart-footer-savings]').forEach((target) => {
        const shouldShowShippingPrompt = breakdown.hasItems && breakdown.savings <= 0 && breakdown.shippingCharge > 0;
        const shouldShowRibbon = breakdown.hasSavings || shouldShowShippingPrompt;
        const textTarget = target.querySelector('[data-clean-cart-footer-savings-text]');

        target.hidden = !shouldShowRibbon;
        target.classList.toggle('clean-cart-drawer__savings-ribbon--shipping-prompt', shouldShowShippingPrompt);
        if (textTarget) {
          if (shouldShowShippingPrompt) {
            setCleanCartMoneyText(textTarget, breakdown.freeShippingAmountRemaining, drawer, {
              prefix: 'Add products worth ',
              suffix: ' to get free shipping!',
            });
          } else if (breakdown.hasSavings) {
            setCleanCartMoneyText(textTarget, breakdown.totalSavings, drawer, { suffix: ' saved so far!' });
          } else {
            textTarget.replaceChildren();
          }
        }
      });
      drawer.querySelectorAll('[data-clean-cart-reward-detail]').forEach((target) => {
        const shouldShowRewardDetail = breakdown.hasItems;
        target.hidden = !shouldShowRewardDetail;

        if (!shouldShowRewardDetail) {
          target.replaceChildren();
        } else if (!breakdown.hasFreeShipping) {
          setCleanCartMoneyParts(
            target,
            ['Add ', { money: breakdown.freeShippingAmountRemaining }, ' more for free delivery'],
            drawer,
          );
        } else if (rewardState.nextMilestone) {
          setCleanCartMoneyParts(
            target,
            [
              'Add ',
              { money: rewardState.remainingToNextMilestone },
              ' more → unlock ',
              { money: rewardState.nextMilestone.discount },
              ' off',
            ],
            drawer,
          );
        } else {
          target.textContent = 'All rewards unlocked!';
        }
      });
      updateCleanCartRewardCelebration(
        drawer,
        breakdown.hasItems && breakdown.hasFreeShipping && !rewardState.nextMilestone,
      );
      drawer
        .querySelectorAll('[data-clean-cart-summary-mrp]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.mrpTotal, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-discount-row]')
        .forEach((target) => (target.hidden = breakdown.savings <= 0));
      drawer
        .querySelectorAll('[data-clean-cart-summary-discount]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.savings, drawer, { prefix: '-' }));
      drawer.querySelectorAll('[data-clean-cart-summary-shipping]').forEach((target) => {
        const compareTarget = target.querySelector('[data-clean-cart-summary-shipping-compare]');
        const currentTarget = target.querySelector('[data-clean-cart-summary-shipping-current]');

        target.classList.toggle('clean-cart-drawer__summary-shipping--free', breakdown.hasFreeShipping);
        if (compareTarget) {
          compareTarget.hidden = !breakdown.hasFreeShipping;
          setCleanCartMoneyText(compareTarget, cleanCartStandardShippingCharge, drawer);
        }
        if (currentTarget) {
          if (breakdown.hasFreeShipping) {
            currentTarget.removeAttribute('data-clean-money');
            currentTarget.removeAttribute('data-clean-money-minor');
            currentTarget.removeAttribute('data-clean-money-currency');
            currentTarget.removeAttribute('data-clean-money-source-text');
            currentTarget.removeAttribute('data-clean-money-display-currency');
            currentTarget.removeAttribute('aria-label');
            currentTarget.textContent = 'FREE';
          } else {
            setCleanCartMoneyText(currentTarget, cleanCartStandardShippingCharge, drawer);
          }
        }
      });
      drawer
        .querySelectorAll('[data-clean-cart-summary-total-savings-row]')
        .forEach((target) => (target.hidden = !breakdown.hasSavings));
      drawer
        .querySelectorAll('[data-clean-cart-summary-total-savings]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.totalSavings, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-subtotal]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.cartTotal, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-total]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.estimatedTotal, drawer));
    };

    const getCleanCartProductJson = async (handle, { retries = 0, signal } = {}) => {
      const cleanHandle = String(handle || '').trim();
      if (!cleanHandle) return null;

      if (!cleanCartProductCache.has(cleanHandle)) {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const productUrl = `${rootUrl.replace(/\/?$/, '/')}products/${encodeURIComponent(cleanHandle)}.js`;
        const requestPromise = (async () => {
          for (let attempt = 0; attempt <= retries; attempt += 1) {
            try {
              const response = await fetch(productUrl, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
                signal,
              });

              if (response.ok) {
                const product = await response.json();
                return product;
              }

              const isTransientResponse = response.status === 408 || response.status === 429 || response.status >= 500;
              if (!isTransientResponse) return null;
            } catch (error) {
              if (error?.name === 'AbortError') return null;
              if (attempt === retries) return null;
            }

            if (attempt < retries) {
              await new Promise((resolve) => {
                const timer = window.setTimeout(resolve, 200 * 2 ** attempt);
                signal?.addEventListener(
                  'abort',
                  () => {
                    window.clearTimeout(timer);
                    resolve();
                  },
                  { once: true },
                );
              });
              if (signal?.aborted) return null;
            }
          }

          return null;
        })();

        cleanCartProductCache.set(cleanHandle, requestPromise);
      }

      const cachedRequest = cleanCartProductCache.get(cleanHandle);
      const product = await cachedRequest;

      if (!product && cleanCartProductCache.get(cleanHandle) === cachedRequest) {
        cleanCartProductCache.delete(cleanHandle);
      }

      return product;
    };

    const hydrateCleanCartComparePrices = async (drawer, cart, renderId) => {
      const items = cart?.items || [];
      const compareLinePrices = new Map();
      if (!drawer || !items.length) return;

      if (drawer.hidden || !drawer.classList.contains('clean-cart-drawer--open')) {
        cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
        return;
      }

      cleanCartPendingCompareHydrations.delete(drawer);

      const itemNodes = new Map(
        Array.from(drawer.querySelectorAll('[data-clean-cart-item]')).map((element) => [
          String(element.dataset.cleanCartItem || ''),
          element,
        ]),
      );
      const itemsByHandle = new Map();

      items.forEach((item) => {
        const itemKey = getCleanCartItemKey(item);
        const directCompareLinePrice = getCleanCartCompareAtLinePrice(item);
        if (directCompareLinePrice) compareLinePrices.set(itemKey, directCompareLinePrice);
        if (hasCleanCartDirectCompareAtPrice(item) || !item?.handle) return;

        const handle = String(item.handle);
        if (!itemsByHandle.has(handle)) itemsByHandle.set(handle, []);
        itemsByHandle.get(handle).push(item);
      });

      const handleEntries = Array.from(itemsByHandle.entries());
      let handleIndex = 0;
      let didHydrateComparePrice = false;

      const hydrateNextHandle = async () => {
        while (handleIndex < handleEntries.length) {
          if (
            drawer.hidden ||
            !drawer.classList.contains('clean-cart-drawer--open') ||
            drawer.dataset.cleanCartRenderId !== renderId
          ) {
            cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
            return;
          }

          const [handle, handleItems] = handleEntries[handleIndex];
          handleIndex += 1;
          const product = await getCleanCartProductJson(handle);
          const variants = new Map((product?.variants || []).map((variant) => [String(variant?.id || ''), variant]));

          if (
            drawer.hidden ||
            !drawer.classList.contains('clean-cart-drawer--open') ||
            drawer.dataset.cleanCartRenderId !== renderId
          ) {
            cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
            return;
          }

          handleItems.forEach((item) => {
            const itemKey = getCleanCartItemKey(item);
            const variant = variants.get(String(item?.variant_id || item?.id || ''));
            const compareLinePrice = getCleanCartCompareAtLinePrice(
              item,
              cleanNormalizeCartPrice(variant?.compare_at_price),
            );
            if (!compareLinePrice) return;

            compareLinePrices.set(itemKey, compareLinePrice);
            const priceBlock = itemNodes.get(String(item.key || ''))?.querySelector('[data-clean-cart-price-block]');
            const nextPriceHtml = renderCleanCartPriceHtml(item, drawer, compareLinePrice);

            if (priceBlock && priceBlock.innerHTML !== nextPriceHtml) {
              priceBlock.innerHTML = nextPriceHtml;
            }

            didHydrateComparePrice = true;
          });
        }
      };

      await Promise.all(
        Array.from({ length: Math.min(cleanCartCompareHydrationConcurrency, handleEntries.length) }, hydrateNextHandle),
      );

      if (didHydrateComparePrice && drawer.dataset.cleanCartRenderId === renderId && !drawer.hidden) {
        renderCleanCartTotals(drawer, cart, compareLinePrices);
      }
    };

    const resumeCleanCartCompareHydration = (drawer) => {
      const pending = cleanCartPendingCompareHydrations.get(drawer);
      if (!pending || drawer?.dataset.cleanCartRenderId !== pending.renderId) return;
      hydrateCleanCartComparePrices(drawer, pending.cart, pending.renderId).catch(() => {});
    };

    window.CleanGokwik =
      window.CleanGokwik ||
      (() => {
        const state = {
          countryPromise: null,
          scriptPromise: null,
        };

        const readDetectedCountry = async () => {
          if (state.countryPromise) return state.countryPromise;

          state.countryPromise = (async () => {
            try {
              const cachedCountry = sessionStorage.getItem('cleanGokwikCountry');
              if (cachedCountry) return cachedCountry;

              const response = await fetch('/browsing_context_suggestions.json', {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
              });
              if (!response.ok) return '';

              const data = await response.json();
              const detected = data?.detected_values || {};
              const country =
                detected.country_code ||
                detected.country?.iso_code ||
                detected.country?.handle ||
                (detected.country_name === 'India' ? 'IN' : detected.country_name || '');
              const normalizedCountry = String(country || '').toUpperCase();

              sessionStorage.setItem('cleanGokwikCountry', normalizedCountry);
              return normalizedCountry;
            } catch (error) {
              return '';
            }
          })();

          return state.countryPromise;
        };

        const scriptHostForEnv = (environment) => {
          const normalizedEnvironment = environment || 'production';
          if (normalizedEnvironment === 'production') return 'pdp.gokwik.co';
          if (normalizedEnvironment === 'sandbox') return 'sandbox.pdp.gokwik.co';
          return 'qa.pdp.gokwik.co';
        };

        const loadSdk = (scope) => {
          if (typeof window.onCheckoutClick === 'function') {
            return Promise.resolve();
          }
          if (state.scriptPromise) return state.scriptPromise;

          window.merchantInfo = {
            mid: scope.dataset.cleanGokwikMid || '',
            environment: scope.dataset.cleanGokwikEnv || 'production',
            type: 'merchantInfo',
            storeId: scope.dataset.cleanGokwikStoreId || '',
            fbpixel: scope.dataset.cleanGokwikFbpixel || '',
          };
          window.productFormSelector = window.productFormSelector || '';
          window.templateName =
            window.templateName || (scope.matches('[data-clean-cart-page]') ? 'cart' : 'product');

          state.scriptPromise = new Promise((resolve, reject) => {
            let isSettled = false;
            const scriptUrl = `https://${scriptHostForEnv(scope.dataset.cleanGokwikEnv)}/merchant-integration/build/merchant.integration.js?v4`;
            const existingScript =
              document.getElementById('gokwik-merchant-integration') ||
              document.querySelector(
                '[data-clean-gokwik-sdk], script[src*="merchant-integration/build/merchant.integration.js"]',
              );
            let readyTimer = null;
            let readyTimeout = null;
            const cleanup = () => {
              window.clearInterval(readyTimer);
              window.clearTimeout(readyTimeout);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
            };
            const finish = () => {
              if (isSettled || typeof window.onCheckoutClick !== 'function') return;
              isSettled = true;
              cleanup();
              resolve();
            };
            const fail = (message = 'GoKwik checkout is not ready yet.') => {
              if (isSettled) return;
              isSettled = true;
              cleanup();
              state.scriptPromise = null;
              reject(new Error(message));
            };

            document.addEventListener('gokwikLoaded', finish);
            window.addEventListener('gokwikLoaded', finish);
            readyTimer = window.setInterval(finish, 100);
            readyTimeout = window.setTimeout(() => fail(), 8000);

            if (existingScript) {
              existingScript.id = 'gokwik-merchant-integration';
              existingScript.setAttribute('data-hadiyah-tp-ok', '1');
              existingScript.dataset.cleanGokwikSdk = 'true';
              existingScript.addEventListener('error', () => fail('Unable to load GoKwik checkout.'), {
                once: true,
              });
              if (!existingScript.getAttribute('src')) {
                existingScript.removeAttribute('type');
                existingScript.removeAttribute('data-hadiyah-tp-deferred');
                existingScript.src = scriptUrl;
              }
              finish();
              return;
            }

            const script = document.createElement('script');
            script.id = 'gokwik-merchant-integration';
            script.setAttribute('data-hadiyah-tp-ok', '1');
            script.defer = true;
            script.dataset.cleanGokwikSdk = 'true';
            script.src = scriptUrl;
            script.onload = () => {
              window.setTimeout(finish, 0);
            };
            script.onerror = () => fail('Unable to load GoKwik checkout.');
            document.head.appendChild(script);
          });

          return state.scriptPromise;
        };

        const setScopeVisibility = (scope, useGokwik) => {
          const gokwikButton = scope.querySelector('[data-clean-gokwik-checkout]');
          const shopifyCheckout = scope.querySelector('[data-clean-shopify-checkout]');
          const gokwikReady = useGokwik && typeof window.onCheckoutClick === 'function';

          if (!gokwikReady || !gokwikButton) {
            if (shopifyCheckout) shopifyCheckout.hidden = false;
            if (!gokwikButton) return;

            gokwikButton.hidden = true;
            gokwikButton.setAttribute('aria-hidden', 'true');
            return;
          }

          gokwikButton.hidden = false;
          gokwikButton.setAttribute('aria-hidden', 'false');
          if (shopifyCheckout) shopifyCheckout.hidden = true;
        };

        const getScopeCountry = (scope) => String(scope?.dataset.cleanGokwikCountry || '').toUpperCase();

        const isGokwikCountry = (country) => country === 'IN' || country === 'INDIA';

        const syncScope = async (scope, { detect = false, prepare = false } = {}) => {
          if (!scope) return false;

          setScopeVisibility(scope, false);
          if (scope.dataset.cleanGokwikEnabled !== 'true') return false;

          const selectedCountry = getScopeCountry(scope);
          if (!isGokwikCountry(selectedCountry)) return false;

          const sdkReadyPromise = prepare
            ? loadSdk(scope)
                .then(() => true)
                .catch(() => false)
            : Promise.resolve(typeof window.onCheckoutClick === 'function');
          const detectedCountry = detect ? await readDetectedCountry() : selectedCountry;

          if (!isGokwikCountry(detectedCountry)) return false;

          const sdkReady = await sdkReadyPromise;
          const useGokwik = sdkReady && typeof window.onCheckoutClick === 'function';
          setScopeVisibility(scope, useGokwik);

          return useGokwik;
        };

        const fallbackToShopify = (scope, reason) => {
          if (scope) setScopeVisibility(scope, false);

          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'gokwik_fallback_used',
              path: window.location.pathname,
              reason,
            });
          } catch (error) {}

          const shopifyCheckout = scope?.querySelector('[data-clean-shopify-checkout]');
          const checkoutUrl =
            shopifyCheckout?.getAttribute('href') || scope?.dataset.cleanCartCheckoutUrl || '/checkout';
          window.location.assign(checkoutUrl);
          return false;
        };

        const checkout = async (button, scope) => {
          try {
            if (!scope || scope.dataset.cleanGokwikEnabled !== 'true') {
              return fallbackToShopify(scope, 'scope_unavailable');
            }

            const useGokwik = await syncScope(scope, { detect: true, prepare: true });
            if (!useGokwik || typeof window.onCheckoutClick !== 'function') {
              return fallbackToShopify(scope, 'checkout_not_ready');
            }

            try {
              window.onCheckoutClick(button);
              return true;
            } catch (error) {
              return fallbackToShopify(scope, 'checkout_handler_threw');
            }
          } catch (error) {
            return fallbackToShopify(scope, 'checkout_exception');
          }
        };

        return { checkout, fallbackToShopify, syncScope };
      })();

    const getCleanCartDrawer = () => document.querySelector('[data-clean-cart-drawer]');

    if (!customElements.get('cart-drawer')) {
      class CleanHadiyahCartDrawer extends HTMLElement {
        setActiveElement(element) {
          this.cleanCartActiveElement = element;
        }

        getSectionsToRender() {
          return [{ id: 'cart-icon-bubble' }];
        }

        async renderContents(parsedState, options = {}) {
          try {
            let cart = null;
            const isCompleteCart =
              Array.isArray(parsedState?.items) && Number.isFinite(Number(parsedState?.item_count));

            if (isCompleteCart) {
              cart = parsedState;
              renderCleanCartItems(this, cart);
              broadcastCleanCart(cart, 'hadiyah-cart-render');
            } else {
              cart = await refreshCleanCartDrawer(this);
            }

            if (options.openDrawer !== false) {
              await openCleanCartDrawer({ refresh: false });
            }

            return cart;
          } catch (error) {
            setCleanCartStatus(this, error?.message || 'Unable to refresh cart.');

            if (options.openDrawer !== false) {
              await openCleanCartDrawer({ refresh: false });
            }

            return null;
          }
        }

        open(triggeredBy) {
          if (triggeredBy) this.setActiveElement(triggeredBy);
          return openCleanCartDrawer();
        }

        close() {
          const focusTarget = this.cleanCartActiveElement;
          closeCleanCartDrawer();

          window.setTimeout(
            () => {
              if (focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
            },
            reducedMotion.matches ? 0 : 220,
          );
        }
      }

      customElements.define('cart-drawer', CleanHadiyahCartDrawer);
    }


    const getCleanCartUrl = (drawer, key, fallback) => drawer?.dataset[key] || fallback;

    const getCleanCartJsonUrl = (drawer) => {
      const cartUrl = getCleanCartUrl(drawer, 'cleanCartUrl', '/cart');
      return cleanCartAjaxUrl(cartUrl, '/cart');
    };

    const setCleanCartStatus = (drawer, message = '') => {
      const status = drawer?.querySelector('[data-clean-cart-drawer-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const setCleanCartInputValue = (input, value = '') => {
      if (!input || document.activeElement === input) return;
      input.value = value || '';
    };

    const getCleanCartGiftWrapVariantId = (drawer) => String(drawer?.dataset.cleanCartGiftWrapVariantId || '').trim();

    const isCleanCartGiftWrapItem = (item, variantId) => {
      const giftWrapVariantId = String(variantId || '').trim();
      if (!giftWrapVariantId) return false;

      return String(item?.id || '') === giftWrapVariantId || String(item?.variant_id || '') === giftWrapVariantId;
    };

    const hasCleanCartGiftWrapItem = (cart, variantId) => {
      const giftWrapVariantId = String(variantId || '').trim();
      if (!giftWrapVariantId) return false;

      return (cart?.items || []).some((item) => isCleanCartGiftWrapItem(item, giftWrapVariantId));
    };

    const syncCleanCartToolCount = (drawer) => {
      const tools = drawer?.querySelector('[data-clean-cart-tools]');
      if (!tools) return;

      const visibleToolCount = [...tools.querySelectorAll('[data-clean-cart-tool-trigger]')].filter(
        (button) => !button.hidden,
      ).length;
      tools.dataset.cleanCartToolsCount = String(Math.max(visibleToolCount, 1));
    };

    const syncCleanCartGiftWrapTool = (drawer, cart) => {
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);
      const giftWrapTool = drawer?.querySelector('[data-clean-cart-gift-wrap-tool]');
      const giftWrapPanel = drawer?.querySelector('[data-clean-cart-tool-panel="gift-wrap"]');
      const hasGiftWrap = hasCleanCartGiftWrapItem(cart, giftWrapVariantId);
      const shouldShowGiftWrap = Boolean(giftWrapVariantId);

      if (giftWrapTool) {
        giftWrapTool.hidden = !shouldShowGiftWrap;
        giftWrapTool.disabled = hasGiftWrap;
        giftWrapTool.setAttribute('aria-disabled', String(hasGiftWrap));
        if (!shouldShowGiftWrap || hasGiftWrap) giftWrapTool.setAttribute('aria-expanded', 'false');
      }

      if ((!shouldShowGiftWrap || hasGiftWrap) && giftWrapPanel) {
        giftWrapPanel.hidden = true;
      }

      if (!drawer?.querySelector('[data-clean-cart-tool-panel]:not([hidden])')) {
        drawer?.classList.remove('clean-cart-drawer--tool-open');
      }

      syncCleanCartToolCount(drawer);
    };

    const syncCleanCartToolFields = (drawer, cart) => {
      if (!drawer || !cart) return;

      const attributes = cart.attributes || {};

      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-note-input]'), cart.note || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-to]'), attributes.To || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-from]'), attributes.From || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-message]'), attributes.Message || '');
      syncCleanCartGiftWrapTool(drawer, cart);
    };

    const syncCleanCartToolViewport = (drawer) => {
      if (!drawer) return;

      const visualViewport = window.visualViewport;
      const visualHeight = Math.max(0, visualViewport?.height || window.innerHeight);
      const visualOffsetTop = Math.max(0, visualViewport?.offsetTop || 0);
      const keyboardInset = Math.max(0, window.innerHeight - visualHeight - visualOffsetTop);

      drawer.style.setProperty('--clean-cart-tool-viewport-height', `${visualHeight}px`);
      drawer.style.setProperty('--clean-cart-tool-keyboard-inset', `${keyboardInset}px`);
    };

    const resetCleanCartToolViewport = (drawer) => {
      drawer?.style.removeProperty('--clean-cart-tool-viewport-height');
      drawer?.style.removeProperty('--clean-cart-tool-keyboard-inset');
    };

    const closeCleanCartToolPanel = (drawer = getCleanCartDrawer(), { restoreFocus = true } = {}) => {
      if (!drawer) return;

      drawer.classList.remove('clean-cart-drawer--tool-open');
      drawer.querySelectorAll('[data-clean-cart-tool-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      drawer.querySelectorAll('[data-clean-cart-tool-panel]').forEach((panel) => {
        panel.hidden = true;
      });

      resetCleanCartToolViewport(drawer);

      const restoreTarget = drawer.cleanCartToolRestoreFocus;
      drawer.cleanCartToolRestoreFocus = null;
      if (restoreFocus && restoreTarget?.isConnected && !restoreTarget.disabled) {
        restoreTarget.focus({ preventScroll: true });
      }
    };

    const openCleanCartToolPanel = (drawer, toolName) => {
      if (!drawer || !toolName) return;

      drawer.cleanCartToolRestoreFocus = document.activeElement;
      drawer.classList.add('clean-cart-drawer--tool-open');
      syncCleanCartToolViewport(drawer);
      drawer.querySelectorAll('[data-clean-cart-tool-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', String(button.dataset.cleanCartToolTrigger === toolName));
      });
      drawer.querySelectorAll('[data-clean-cart-tool-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.cleanCartToolPanel !== toolName;
      });

      const panel = drawer.querySelector(`[data-clean-cart-tool-panel="${toolName}"]`);
      const firstField = panel?.querySelector('textarea, [data-clean-cart-tool-save]');
      const panelBody = panel?.querySelector('.clean-cart-drawer__tool-panel-body');

      if (panel) panel.scrollTop = 0;
      if (panelBody) panelBody.scrollTop = 0;
      firstField?.focus({ preventScroll: true });
    };

    const updateCleanCartDetails = async (drawer, entries = {}) => {
      const body = new FormData();

      Object.entries(entries).forEach(([name, value]) => {
        body.append(name, value || '');
      });

      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartUpdateUrl', '/cart/update'), '/cart/update'),
        {
          method: 'POST',
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to save cart details.');
      }

      const cart = await response.json();
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const addCleanCartGiftWrap = async (drawer) => {
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);

      if (!giftWrapVariantId) {
        throw new Error('Gift wrap is not available.');
      }

      if (hasCleanCartGiftWrapItem(window.cart, giftWrapVariantId)) {
        return refreshCleanCartDrawer(drawer);
      }

      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartAddUrl', '/cart/add'), '/cart/add'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftWrapVariantId,
            quantity: 1,
          }),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to add gift wrap.');
      }

      return refreshCleanCartDrawer(drawer);
    };

    const saveCleanCartToolPanel = async (drawer, toolName, saveButton) => {
      if (!drawer || !toolName || !saveButton) return;

      const originalLabel = saveButton.textContent.trim();
      saveButton.disabled = true;
      saveButton.textContent = 'Saving...';
      setCleanCartStatus(drawer);

      try {
        if (toolName === 'instructions') {
          await updateCleanCartDetails(drawer, {
            note: drawer.querySelector('[data-clean-cart-note-input]')?.value || '',
          });
        }

        if (toolName === 'gift-wrap') {
          await addCleanCartGiftWrap(drawer);
        }

        if (toolName === 'card') {
          await updateCleanCartDetails(drawer, {
            'attributes[To]': drawer.querySelector('[data-clean-cart-card-to]')?.value || '',
            'attributes[From]': drawer.querySelector('[data-clean-cart-card-from]')?.value || '',
            'attributes[Message]': drawer.querySelector('[data-clean-cart-card-message]')?.value || '',
          });
        }

        closeCleanCartToolPanel(drawer);
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to save cart details.');
      } finally {
        saveButton.disabled = false;
        saveButton.textContent = originalLabel;
      }
    };

    const updateCleanCartCountTargets = (itemCount) => {
      document.querySelectorAll('[data-clean-cart-count], [data-cart-count]').forEach((target) => {
        target.textContent = String(itemCount);
      });
    };

    const cleanCartNameOnCakePropertyName = 'Name On Cake';
    const cleanCartNameOnCakePropertyHandle = cleanCartNameOnCakePropertyName.toLowerCase();

    const cleanCartPropertyStringValue = (value) => (Array.isArray(value) ? value.join(', ') : String(value ?? ''));

    const isCleanCartPreviewProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase()
        .startsWith('preview.');

    const isCleanCartNameOnCakeProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase() === cleanCartNameOnCakePropertyHandle;

    const getCleanCartItemByKey = (key) =>
      (window.cart?.items || []).find((item) => String(item?.key || '') === String(key || ''));

    const getCleanCartPreviewUrls = (value) => {
      const values = Array.isArray(value) ? value : [value];
      const urls = [];

      values.forEach((item) => {
        const matches = String(item ?? '').match(/https?:\/\/[^\s,]+/gi) || [];

        matches.forEach((match) => {
          const candidate = match.replace(/^[('"[]+|[)'"\]]+$/g, '');

          try {
            const url = new URL(candidate);
            if ((url.protocol === 'http:' || url.protocol === 'https:') && !urls.includes(url.href)) {
              urls.push(url.href);
            }
          } catch (error) {
            // Ignore malformed preview URLs and fall back to the raw property value below.
          }
        });
      });

      return urls;
    };

    const renderCleanCartPreviewControl = (previewUrls = [], item = {}) => {
      const urls = (previewUrls || []).filter(Boolean);
      if (!urls.length) return '';

      const productTitle = String(item.product_title || item.title || '').trim();
      const label = urls.length > 1 ? `View Preview (${urls.length})` : 'View Preview';

      // Put URLs on the button — <script> JSON inside innerHTML is unreliable.
      return `
        <span class="cart-item__custom-preview">
          <button
            type="button"
            class="clean-cart-drawer__meta-link cart-item__preview-open"
            data-cart-preview-open
            data-cart-preview-urls="${escapeCleanCartHtml(urls.join('|'))}"
            data-cart-preview-product="${escapeCleanCartHtml(productTitle)}"
            data-cart-preview-product-url="${escapeCleanCartHtml(item.url || '')}"
            data-cart-preview-line-key="${escapeCleanCartHtml(item.key || '')}"
          >
            ${escapeCleanCartHtml(label)}
          </button>
        </span>
      `;
    };

    const renderCleanCartPropertyValue = (name, value, item = {}) => {
      const previewUrls = isCleanCartPreviewProperty(name) ? getCleanCartPreviewUrls(value) : [];

      if (previewUrls.length) {
        return renderCleanCartPreviewControl(previewUrls, item);
      }

      return escapeCleanCartHtml(cleanCartPropertyStringValue(value));
    };

    const renderCleanCartPropertyLabel = (name) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      if (normalizedName === 'preview.effects') return '';
      if (normalizedName === 'preview.texts') return 'Text';
      if (normalizedName === 'preview.images') return 'Photos';
      return name;
    };

    const isCleanCartZipcodeProperty = (name) =>
      ['pincode', 'delivery tier', 'delivery estimate', 'delivery speed'].includes(
        String(name || '')
          .trim()
          .toLowerCase(),
      );

    const renderCleanCartVariantOptions = (item = {}) => {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const visibleOptions = options.filter((option) => {
        const name = String(option?.name || '').trim();
        const value = String(option?.value || '').trim();
        return name && value && value !== 'Default Title';
      });

      if (visibleOptions.length) {
        return `
          <dl class="clean-cart-drawer__meta clean-cart-drawer__meta--variants">
            ${visibleOptions
              .map(
                (option) => `
                  <div class="clean-cart-drawer__meta-row">
                    <dt>${escapeCleanCartHtml(option.name)}:</dt>
                    <dd>${escapeCleanCartHtml(option.value)}</dd>
                  </div>
                `,
              )
              .join('')}
          </dl>
        `;
      }

      const variantTitle = String(item.variant_title || '').trim();
      if (!variantTitle || variantTitle === 'Default Title') return '';

      return `
        <dl class="clean-cart-drawer__meta clean-cart-drawer__meta--variants">
          <div class="clean-cart-drawer__meta-row">
            <dt>Variant:</dt>
            <dd>${escapeCleanCartHtml(variantTitle)}</dd>
          </div>
        </dl>
      `;
    };

    const renderCleanCartNameOnCakeProperty = (value) => {
      const stringValue = cleanCartPropertyStringValue(value);
      const escapedValue = escapeCleanCartHtml(stringValue);

      return `
        <div class="clean-cart-drawer__meta-row clean-cart-drawer__meta-row--editable" data-clean-cart-name-on-cake-row>
          <dt>${escapeCleanCartHtml(cleanCartNameOnCakePropertyName)}:</dt>
          <dd>
            <span class="clean-cart-drawer__property-view" data-clean-cart-name-on-cake-view>
              <span data-clean-cart-name-on-cake-value>${escapedValue}</span>
              <button
                class="clean-cart-drawer__property-edit"
                type="button"
                aria-label="Edit name on cake"
                data-clean-cart-edit-name-on-cake
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="m4 20 4.5-1 10-10a2.1 2.1 0 0 0-3-3l-10 10L4 20Z"></path>
                  <path d="m13.5 7.5 3 3"></path>
                </svg>
              </button>
            </span>
            <span class="clean-cart-drawer__property-editor" data-clean-cart-name-on-cake-editor hidden>
              <input
                class="clean-cart-drawer__property-input"
                type="text"
                value="${escapedValue}"
                autocomplete="off"
                aria-label="Name On Cake"
                data-clean-cart-name-on-cake-input
              >
              <button
                class="clean-cart-drawer__property-action clean-cart-drawer__property-action--save"
                type="button"
                data-clean-cart-save-name-on-cake
              >
                Save
              </button>
              <button
                class="clean-cart-drawer__property-action"
                type="button"
                data-clean-cart-cancel-name-on-cake
              >
                Cancel
              </button>
            </span>
          </dd>
        </div>
      `;
    };

    const renderCleanCartProperties = (properties = {}, item = {}) => {
      const entries = Object.entries(properties).filter(([name, value]) => {
        const stringValue = cleanCartPropertyStringValue(value);
        return name && !name.startsWith('_') && !isCleanCartZipcodeProperty(name) && stringValue.trim() !== '';
      });

      if (!entries.length) return '';

      const visibleEntries = entries.filter(
        ([name]) =>
          ['Delivery Date', 'Delivery Day', 'Delivery Time', 'Name On Cake'].includes(name) ||
          isCleanCartPreviewProperty(name),
      );
      const fallbackEntries = visibleEntries.length ? visibleEntries : entries.slice(0, 3);

      return `
        <dl class="clean-cart-drawer__meta">
          ${fallbackEntries
            .map(([name, value]) => {
              if (isCleanCartNameOnCakeProperty(name)) {
                return renderCleanCartNameOnCakeProperty(value);
              }

              const label = renderCleanCartPropertyLabel(name);
              return `
                <div class="clean-cart-drawer__meta-row">
                  ${label ? `<dt>${escapeCleanCartHtml(label)}:</dt>` : ''}
                  <dd>${renderCleanCartPropertyValue(name, value, item)}</dd>
                </div>
              `;
            })
            .join('')}
        </dl>
      `;
    };

    const isCleanCartAddOnItem = (item = {}) => {
      const properties = item?.properties || {};
      return (
        String(properties['_Add-on upsell'] || '').trim().toLowerCase() === 'yes' ||
        String(properties['_Add-on source'] || '').trim().toLowerCase() === 'post add-to-cart drawer'
      );
    };

    const renderCleanCartItems = (drawer, cart) => {
      const itemsTarget = drawer?.querySelector('[data-clean-cart-drawer-items]');
      const countTarget = drawer?.querySelector('[data-clean-cart-drawer-count]');
      const totalTarget = drawer?.querySelector('[data-clean-cart-drawer-total]');
      const footer = drawer?.querySelector('[data-clean-cart-drawer-footer]');
      const checkout = drawer?.querySelector('.clean-cart-drawer__checkout');
      const gokwikCheckout = drawer?.querySelector('[data-clean-gokwik-checkout]');

      if (!itemsTarget || !countTarget || !totalTarget) return;

      const renderId = String(++cleanCartRenderSequence);
      drawer.dataset.cleanCartRenderId = renderId;
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);
      const itemCount = Number(cart?.item_count || 0);
      const itemText = itemCount === 1 ? 'item' : 'items';
      itemsTarget.classList.toggle('clean-cart-drawer__items--empty', itemCount === 0);
      if (footer) footer.hidden = itemCount === 0;
      countTarget.textContent = `${itemCount} ${itemText}`;
      renderCleanCartTotals(drawer, cart);
      window.cart = cart;
      drawer.cleanCartRenderedCart = cart;
      syncCleanCartToolFields(drawer, cart);
      updateCleanCartCountTargets(itemCount);

      [checkout, gokwikCheckout].forEach((target) => {
        if (!target) return;

        if (itemCount === 0) {
          target.setAttribute('aria-disabled', 'true');
        } else {
          target.removeAttribute('aria-disabled');
        }
      });

      if (!itemCount) {
        const emptyTemplate = drawer.querySelector('[data-clean-cart-empty-template]');
        if (emptyTemplate) {
          itemsTarget.replaceChildren(emptyTemplate.content.cloneNode(true));
        } else {
          itemsTarget.replaceChildren();
        }
        return;
      }

      const addOnsWereOpen = itemsTarget.querySelector('[data-clean-cart-drawer-add-ons]')?.open ?? true;
      const ordinaryItems = cart.items.filter((item) => !isCleanCartAddOnItem(item));
      const addOnItems = cart.items.filter((item) => isCleanCartAddOnItem(item));
      const addOnQuantity = addOnItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
      const renderItem = (item) => {
        const isGiftWrapItem = isCleanCartGiftWrapItem(item, giftWrapVariantId);
        const isAddOnItem = isCleanCartAddOnItem(item);
        const itemImage = item.image
          ? `<img class="clean-cart-drawer__image" src="${escapeCleanCartHtml(
              getCleanCartImageUrl(item.image),
            )}" alt="${escapeCleanCartHtml(item.product_title || item.title)}" width="70" height="70" loading="lazy">`
          : '<div class="clean-cart-drawer__image" aria-hidden="true"></div>';
        const quantityControls = isGiftWrapItem
          ? ''
          : `
                <div class="clean-cart-drawer__quantity" data-clean-cart-quantity>
                  <button type="button" aria-label="Decrease quantity" data-clean-cart-quantity-decrease>-</button>
                  <input
                    type="number"
                    min="0"
                    value="${Number(item.quantity || 0)}"
                    inputmode="numeric"
                    aria-label="Quantity for ${escapeCleanCartHtml(item.product_title || item.title)}"
                    data-clean-cart-quantity-input
                  >
                  <button type="button" aria-label="Increase quantity" data-clean-cart-quantity-increase>+</button>
                </div>
              `;

        return `
            <article class="clean-cart-drawer__item${
              isAddOnItem ? ' clean-cart-drawer__item--add-on' : ''
            }" data-clean-cart-item="${escapeCleanCartHtml(item.key)}">
              <a href="${escapeCleanCartHtml(item.url || '#')}" aria-label="${escapeCleanCartHtml(item.title)}">
                ${itemImage}
              </a>
              <div class="clean-cart-drawer__item-body">
                <a class="clean-cart-drawer__item-title" href="${escapeCleanCartHtml(item.url || '#')}">
                  ${escapeCleanCartHtml(item.product_title || item.title)}
                </a>
                ${renderCleanCartVariantOptions(item)}
                ${renderCleanCartProperties(item.properties, item)}
                <div class="clean-cart-drawer__prices" data-clean-cart-price-block>
                  ${renderCleanCartPriceHtml(item, drawer)}
                </div>
                ${quantityControls}
              </div>
              <button class="clean-cart-drawer__remove" type="button" aria-label="Remove ${escapeCleanCartHtml(
                item.product_title || item.title,
              )}" data-clean-cart-remove>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3"></path>
                </svg>
              </button>
              <span class="clean-cart-drawer__item-loading" data-clean-cart-item-loading-label aria-live="polite">
                Updating cart...
              </span>
            </article>
          `;
      };
      const addOnMarkup = addOnItems.map(renderItem).join('');

      itemsTarget.innerHTML = `
        ${ordinaryItems.map(renderItem).join('')}
        ${
          addOnItems.length
            ? `
              <details class="clean-cart-drawer__add-ons" data-clean-cart-drawer-add-ons${
                addOnsWereOpen ? ' open' : ''
              }>
                <summary class="clean-cart-drawer__add-ons-summary">
                  <span>Add-ons</span>
                  <span class="clean-cart-drawer__add-ons-count">${addOnQuantity}</span>
                </summary>
                <div class="clean-cart-drawer__add-ons-items">
                  ${addOnMarkup}
                </div>
              </details>
            `
            : ''
        }
      `;

      hydrateCleanCartComparePrices(drawer, cart, renderId).catch(() => {});
    };

    const setCleanCartItemLoading = (item, isLoading, message = 'Updating cart...') => {
      if (!item) return;

      item.classList.toggle('clean-cart-drawer__item--loading', isLoading);
      item.toggleAttribute('aria-busy', isLoading);
      item.dataset.cleanCartItemLoading = isLoading ? 'true' : 'false';

      const label = item.querySelector('[data-clean-cart-item-loading-label]');
      if (label) label.textContent = message;

      item.querySelectorAll('button, input').forEach((control) => {
        control.disabled = isLoading;
      });
    };

    const changeCleanCartItemWithLoading = async (drawer, item, quantity, message) => {
      const key = item?.dataset.cleanCartItem;
      if (!drawer || !item || !key || item.dataset.cleanCartItemLoading === 'true') return null;

      setCleanCartItemLoading(item, true, message);

      try {
        return await changeCleanCartItem(drawer, key, quantity);
      } finally {
        if (item.isConnected) {
          setCleanCartItemLoading(item, false);
        }
      }
    };

    const fetchCleanCart = async (drawer = getCleanCartDrawer()) => {
      if (!drawer) return null;

      const coordinator = getCleanCartStateCoordinator();
      let cart = await coordinator.refresh(async () => {
        const response = await cleanCartRequest(getCleanCartJsonUrl(drawer));
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      });

      if (drawer.dataset.cleanCartZeroPriceRepairAttempted !== 'true') {
        const zeroPriceUpdates = Object.fromEntries(
          (cart?.items || [])
            .filter(hasCleanCartUnexpectedZeroPrice)
            .map((item) => [String(item.key || '').trim(), cleanClampCartQuantity(item.quantity)])
            .filter(([key, quantity]) => key && quantity > 0),
        );

        if (Object.keys(zeroPriceUpdates).length) {
          drawer.dataset.cleanCartZeroPriceRepairAttempted = 'true';
          const response = await cleanCartRequest(
            cleanCartAjaxUrl(drawer.dataset.cleanCartUpdateUrl, '/cart/update'),
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: zeroPriceUpdates }),
            },
          );

          if (response.ok) {
            cart = await response.json();
            coordinator.publish(cart);
          }
        }
      }

      if (drawer.cleanCartRenderedCart !== cart) renderCleanCartItems(drawer, cart);
      return cart;
    };

    const broadcastCleanCart = (cart, origin = 'clean-cart-drawer') => {
      getCleanCartStateCoordinator().publish(cart);
      document.dispatchEvent(
        new CustomEvent('clean:cart:updated', {
          detail: { cart, origin },
        }),
      );
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            item_count: Number(cart?.item_count || 0),
            cart,
            data: cart,
          },
        }),
      );

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: origin,
          cartData: cart,
        });
      }
    };

    const refreshCleanCartDrawer = async (drawer = getCleanCartDrawer()) => {
      const cart = await fetchCleanCart(drawer);
      if (cart) broadcastCleanCart(cart);
      return cart;
    };

    const animateCleanCartShippingProgress = (drawer) => {
      if (!drawer || drawer.cleanCartShippingProgressAnimated) return false;

      const panel = drawer.querySelector('[data-clean-cart-shipping-progress-panel]');
      if (!panel || panel.hidden) return false;

      const progress = Math.min(100, Math.max(0, Number(panel.dataset.cleanCartShippingProgress) || 0));
      const fill = panel.querySelector('[data-clean-cart-shipping-progress-fill]');
      const truck = panel.querySelector('[data-clean-cart-shipping-progress-truck]');
      if (!fill || !truck) return false;

      drawer.cleanCartShippingProgressAnimated = true;
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        fill.style.width = `${progress}%`;
        truck.style.left = `${progress}%`;
        return true;
      }

      fill.style.transition = 'none';
      truck.style.transition = 'none';
      fill.style.width = '0%';
      truck.style.left = '0%';

      drawer.cleanCartShippingProgressStartFrame = window.requestAnimationFrame(() => {
        drawer.cleanCartShippingProgressEndFrame = window.requestAnimationFrame(() => {
          fill.style.removeProperty('transition');
          truck.style.removeProperty('transition');
          fill.style.width = `${progress}%`;
          truck.style.left = `${progress}%`;
        });
      });

      return true;
    };

    const openCleanCartDrawer = async ({ refresh = true } = {}) => {
      const drawer = getCleanCartDrawer();
      if (!drawer) return;

      setCleanCartStatus(drawer);
      drawer.hidden = false;
      drawer.cleanCartShippingProgressAnimated = false;
      document.body.classList.add('clean-cart-drawer-open');

      window.cancelAnimationFrame(drawer.cleanCartOpenFrame);
      drawer.cleanCartOpenFrame = window.requestAnimationFrame(() => {
        drawer.classList.add('clean-cart-drawer--open');
        resumeCleanCartCompareHydration(drawer);
        if (!refresh) animateCleanCartShippingProgress(drawer);
      });

      window.CleanGokwik.syncScope(drawer, { detect: true, prepare: true }).catch(() => {});

      if (refresh) {
        try {
          await fetchCleanCart(drawer);
          if (drawer.classList.contains('clean-cart-drawer--open')) {
            animateCleanCartShippingProgress(drawer);
          }
        } catch (error) {
          setCleanCartStatus(drawer, error?.message || 'Unable to refresh cart.');
          if (drawer.classList.contains('clean-cart-drawer--open')) {
            animateCleanCartShippingProgress(drawer);
          }
        }
      }
    };

    const closeCleanCartDrawer = () => {
      const drawer = getCleanCartDrawer();
      if (!drawer) return;

      const wasOpen = drawer.classList.contains('clean-cart-drawer--open');
      closeCleanCartToolPanel(drawer, { restoreFocus: false });
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);
      drawer.classList.remove('clean-cart-drawer--open');
      document.body.classList.remove('clean-cart-drawer-open');

      if (wasOpen) {
        document.dispatchEvent(
          new CustomEvent('clean:cart-drawer:closed', {
            detail: { cart: window.cart || null },
          }),
        );
      }

      window.clearTimeout(drawer.cleanCartCloseTimer);
      drawer.cleanCartCloseTimer = window.setTimeout(
        () => {
          if (!drawer.classList.contains('clean-cart-drawer--open')) {
            drawer.hidden = true;
          }
        },
        reducedMotion.matches ? 0 : 220,
      );
    };

    const changeCleanCartItem = async (drawer, key, quantity) => {
      const cleanQuantity = cleanClampCartQuantity(quantity);
      const body = JSON.stringify({ id: key, quantity: cleanQuantity });
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartChangeUrl', '/cart/change'), '/cart/change'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update cart.');
      }

      const cart = await response.json();
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const updateCleanCartItemProperties = async (drawer, key, properties = {}, quantity = 1) => {
      const body = JSON.stringify({
        id: key,
        quantity: cleanClampCartQuantity(quantity),
        properties,
      });
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartChangeUrl', '/cart/change'), '/cart/change'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update cart.');
      }

      const cart = await response.json();
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const setCleanCartNameOnCakeEditing = (row, isEditing) => {
      const view = row?.querySelector('[data-clean-cart-name-on-cake-view]');
      const editor = row?.querySelector('[data-clean-cart-name-on-cake-editor]');
      const input = row?.querySelector('[data-clean-cart-name-on-cake-input]');

      if (!view || !editor || !input) return;

      view.hidden = isEditing;
      editor.hidden = !isEditing;

      if (isEditing) {
        input.value = input.defaultValue;
        input.focus({ preventScroll: true });
        input.select();
      }
    };

    const saveCleanCartNameOnCake = async (drawer, row, saveButton) => {
      const itemElement = row?.closest('[data-clean-cart-item]');
      const key = itemElement?.dataset.cleanCartItem;
      const item = getCleanCartItemByKey(key);
      const input = row?.querySelector('[data-clean-cart-name-on-cake-input]');

      if (!drawer || !row || !saveButton || !key || !item || !input) {
        setCleanCartStatus(drawer, 'Unable to edit the name on cake.');
        return;
      }

      const originalLabel = saveButton.textContent.trim();
      const properties = { ...(item.properties || {}) };
      const propertyName =
        Object.keys(properties).find((name) => isCleanCartNameOnCakeProperty(name)) || cleanCartNameOnCakePropertyName;
      const nextValue = input.value.trim();

      if (nextValue) {
        properties[propertyName] = nextValue;
      } else {
        properties[propertyName] = '';
      }

      saveButton.disabled = true;
      saveButton.textContent = 'Saving';
      setCleanCartStatus(drawer);

      try {
        await updateCleanCartItemProperties(drawer, key, properties, item.quantity || 1);
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to update the name on cake.');
        saveButton.disabled = false;
        saveButton.textContent = originalLabel;
      }
    };

    const addCleanCartForm = async (drawer, productForm) => {
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartAddUrl', '/cart/add'), '/cart/add'),
        {
          method: 'POST',
          body: new FormData(productForm),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to add this item.');
      }

      try {
        const cart = await refreshCleanCartDrawer(drawer);
        return { cart };
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to refresh cart.');
        return { cart: window.cart || null };
      }
    };

    const addCleanCartFormAndOpen = async (productForm) => {
      const drawer = getCleanCartDrawer();
      if (!drawer || !productForm) throw new Error('Cart drawer is not available.');

      setCleanCartStatus(drawer);

      try {
        const { cart } = await addCleanCartForm(drawer, productForm);
        await openCleanCartDrawer({ refresh: false });
        return cart;
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to add this item.');
        throw error;
      }
    };

    const isCleanCartAddUrl = (input) => {
      const rawUrl = typeof input === 'string' ? input : input?.url;
      if (!rawUrl) return false;

      try {
        const url = new URL(rawUrl, window.location.origin);
        return /\/cart\/add(\.js)?$/.test(url.pathname);
      } catch (error) {
        return String(rawUrl).includes('/cart/add');
      }
    };

    const isCleanCartInternalRequest = (init) => {
      try {
        return new Headers(init?.headers || {}).get('X-Clean-Cart') === 'true';
      } catch (error) {
        return false;
      }
    };

    const refreshCleanCartAfterTrackedAdd = async () => {
      const drawer = getCleanCartDrawer();
      if (!drawer) return;

      cleanCartLastTrackedAddAt = Date.now();
      const operation = (async () => {
        const cart = await refreshCleanCartDrawer(drawer);
        await openCleanCartDrawer({ refresh: false });
        return cart;
      })();
      cleanCartTrackedAddPromise = operation;

      try {
        return await operation;
      } finally {
        if (cleanCartTrackedAddPromise === operation) cleanCartTrackedAddPromise = null;
      }
    };

    const initCleanCartDrawer = (root = document) => {
      const drawer = getCleanCartDrawer();
      if (!drawer || drawer.dataset.cleanCartDrawerReady === 'true') return;

      drawer.dataset.cleanCartDrawerReady = 'true';
      const lifecycle = new AbortController();
      drawer.cleanCartDrawerLifecycle = lifecycle;
      syncCleanCartToolCount(drawer);

      const syncToolPanelViewport = () => syncCleanCartToolViewport(drawer);
      window.addEventListener('resize', syncToolPanelViewport, { signal: lifecycle.signal });
      window.visualViewport?.addEventListener('resize', syncToolPanelViewport, {
        signal: lifecycle.signal,
      });
      window.visualViewport?.addEventListener('scroll', syncToolPanelViewport, {
        signal: lifecycle.signal,
      });

      drawer.addEventListener(
        'click',
        (event) => {
          const previewButton = event.target.closest('[data-cart-preview-open], .cart-item__preview-open');
          if (previewButton && drawer.contains(previewButton)) {
            event.preventDefault();
            event.stopPropagation();

            const openPreview = () => {
              if (typeof window.__hadiyahOpenCartPreview === 'function') {
                window.__hadiyahOpenCartPreview(previewButton);
                return true;
              }
              return false;
            };

            if (openPreview()) return;

            if (typeof window.__mountCartPreviewSetup === 'function') {
              window.__mountCartPreviewSetup(() => {
                openPreview();
              });
            }
            return;
          }

          const closeButton = event.target.closest('[data-clean-cart-drawer-close]');
          if (closeButton && drawer.contains(closeButton)) {
            event.preventDefault();
            closeCleanCartDrawer();
            return;
          }

          const summaryToggle = event.target.closest('[data-clean-cart-summary-toggle]');
          if (summaryToggle && drawer.contains(summaryToggle)) {
            event.preventDefault();
            const summary = drawer.querySelector('[data-clean-cart-summary]');
            const isExpanded = summaryToggle.getAttribute('aria-expanded') === 'true';
            summaryToggle.setAttribute('aria-expanded', String(!isExpanded));
            if (summary) summary.hidden = isExpanded;
            return;
          }

          const trigger = event.target.closest('[data-clean-cart-tool-trigger]');
          if (trigger && drawer.contains(trigger)) {
            event.preventDefault();
            if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
            openCleanCartToolPanel(drawer, trigger.dataset.cleanCartToolTrigger);
            return;
          }

          const panelClose = event.target.closest('[data-clean-cart-tool-close]');
          if (panelClose && drawer.contains(panelClose)) {
            event.preventDefault();
            closeCleanCartToolPanel(drawer);
            return;
          }

          if (event.target.closest('[data-clean-cart-tool-cancel]')) {
            event.preventDefault();
            closeCleanCartToolPanel(drawer);
            return;
          }

          const saveButton = event.target.closest('[data-clean-cart-tool-save]');
          if (saveButton && drawer.contains(saveButton)) {
            event.preventDefault();
            saveCleanCartToolPanel(drawer, saveButton.dataset.cleanCartToolSave, saveButton);
          }
        },
        { capture: true, signal: lifecycle.signal },
      );

      drawer.querySelectorAll('[data-clean-gokwik-checkout]').forEach((button) => {
        button.addEventListener(
          'click',
          async (event) => {
            event.preventDefault();

            if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

            button.disabled = true;
            setCleanCartStatus(drawer);

            try {
              await refreshCleanCartDrawer(drawer);
              await window.CleanGokwik.checkout(button, drawer);
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to start GoKwik checkout.');
              window.CleanGokwik.fallbackToShopify(drawer, 'drawer_refresh_failed');
            } finally {
              button.disabled = false;
            }
          },
          { signal: lifecycle.signal },
        );
      });

      drawer.addEventListener(
        'click',
        async (event) => {
          const item = event.target.closest('[data-clean-cart-item]');
          if (!item || !drawer.contains(item)) return;

          const quantityInput = item.querySelector('[data-clean-cart-quantity-input]');

          const editNameOnCakeButton = event.target.closest('[data-clean-cart-edit-name-on-cake]');
          if (editNameOnCakeButton) {
            event.preventDefault();
            setCleanCartNameOnCakeEditing(editNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'), true);
            return;
          }

          const cancelNameOnCakeButton = event.target.closest('[data-clean-cart-cancel-name-on-cake]');
          if (cancelNameOnCakeButton) {
            event.preventDefault();
            setCleanCartNameOnCakeEditing(cancelNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'), false);
            return;
          }

          const saveNameOnCakeButton = event.target.closest('[data-clean-cart-save-name-on-cake]');
          if (saveNameOnCakeButton) {
            event.preventDefault();
            await saveCleanCartNameOnCake(
              drawer,
              saveNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'),
              saveNameOnCakeButton,
            );
            return;
          }

          if (event.target.closest('[data-clean-cart-remove]')) {
            event.preventDefault();
            try {
              await changeCleanCartItemWithLoading(drawer, item, 0, 'Removing...');
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to remove item.');
            }
            return;
          }

          if (event.target.closest('[data-clean-cart-quantity-decrease]')) {
            event.preventDefault();
            try {
              await changeCleanCartItemWithLoading(
                drawer,
                item,
                cleanClampCartQuantity(quantityInput?.value) - 1,
                'Updating cart...',
              );
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
            }
            return;
          }

          if (event.target.closest('[data-clean-cart-quantity-increase]')) {
            event.preventDefault();
            try {
              await changeCleanCartItemWithLoading(
                drawer,
                item,
                cleanClampCartQuantity(quantityInput?.value) + 1,
                'Updating cart...',
              );
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
            }
          }
        },
        { signal: lifecycle.signal },
      );

      drawer.addEventListener(
        'change',
        async (event) => {
          const input = event.target.closest('[data-clean-cart-quantity-input]');
          if (!input || !drawer.contains(input)) return;

          const item = input.closest('[data-clean-cart-item]');
          if (!item) return;

          try {
            await changeCleanCartItemWithLoading(drawer, item, input.value, 'Updating cart...');
          } catch (error) {
            setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
          }
        },
        { signal: lifecycle.signal },
      );

      drawer.addEventListener(
        'keydown',
        async (event) => {
          const input = event.target.closest('[data-clean-cart-name-on-cake-input]');
          if (!input || !drawer.contains(input)) return;

          const row = input.closest('[data-clean-cart-name-on-cake-row]');

          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            setCleanCartNameOnCakeEditing(row, false);
            row?.querySelector('[data-clean-cart-edit-name-on-cake]')?.focus({ preventScroll: true });
            return;
          }

          if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            const saveButton = row?.querySelector('[data-clean-cart-save-name-on-cake]');
            if (!saveButton || saveButton.disabled) return;
            await saveCleanCartNameOnCake(drawer, row, saveButton);
          }
        },
        { signal: lifecycle.signal },
      );

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape' || drawer.hidden) return;

          if (drawer.classList.contains('clean-cart-drawer--tool-open')) {
            closeCleanCartToolPanel(drawer);
            return;
          }

          closeCleanCartDrawer();
        },
        { signal: lifecycle.signal },
      );

      drawer.cleanCartDrawerCleanup = () => {
        lifecycle.abort();
        window.cancelAnimationFrame(drawer.cleanCartOpenFrame);
        window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
        window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);
        window.clearTimeout(drawer.cleanCartCloseTimer);
        window.clearTimeout(drawer.cleanCartRewardCelebrationTimer);
        cleanCartPendingCompareHydrations.delete(drawer);
        delete drawer.dataset.cleanCartDrawerReady;
      };
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCartDrawer(), { once: true });
    } else {
      initCleanCartDrawer();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanCartDrawer(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const cartDrawer =
        event.target.querySelector?.('[data-clean-cart-drawer]') ||
        (event.target.matches?.('[data-clean-cart-drawer]') ? event.target : null);
      cartDrawer?.cleanCartDrawerCleanup?.();
    });

    if (
      getCleanCartDrawer()?.dataset.cleanCartHostAddFlow !== 'true' &&
      document.body.dataset.cleanCartAddWatcherReady !== 'true'
    ) {
      document.body.dataset.cleanCartAddWatcherReady = 'true';

      const nativeFetch = window.fetch;
      window.fetch = function cleanCartDrawerFetch(input, init) {
        const isCartAdd = isCleanCartAddUrl(input);
        const responsePromise = nativeFetch.apply(this, arguments);

        if (isCartAdd && !isCleanCartInternalRequest(init) && getCleanCartDrawer()) {
          responsePromise
            .then((response) => {
              if (response.ok) {
                window.setTimeout(() => {
                  refreshCleanCartAfterTrackedAdd().catch(() => {});
                }, 80);
              }
            })
            .catch(() => {});
        }

        return responsePromise;
      };

      const nativeXhrOpen = window.XMLHttpRequest?.prototype?.open;
      if (nativeXhrOpen) {
        window.XMLHttpRequest.prototype.open = function cleanCartDrawerXhrOpen(method, url) {
          this.cleanCartDrawerTrackedAdd = isCleanCartAddUrl(url);

          if (this.cleanCartDrawerLoadReady !== 'true') {
            this.cleanCartDrawerLoadReady = 'true';
            this.addEventListener('load', function cleanCartDrawerXhrLoad() {
              if (this.cleanCartDrawerTrackedAdd && this.status >= 200 && this.status < 300 && getCleanCartDrawer()) {
                window.setTimeout(() => {
                  refreshCleanCartAfterTrackedAdd().catch(() => {});
                }, 80);
              }
            });
          }

          return nativeXhrOpen.apply(this, arguments);
        };
      }
    }

    window.CleanCart = {
      ...(window.CleanCart || {}),
      addFromForm: addCleanCartFormAndOpen,
      changeItem: changeCleanCartItem,
      fetch: refreshCleanCartDrawer,
      getRecentCart: (maxAge = 2000) => {
        const coordinator = getCleanCartStateCoordinator();
        const isRecent =
          Date.now() - Math.max(cleanCartLastTrackedAddAt, coordinator.state?.lastUpdatedAt || 0) <= maxAge;
        return {
          cart: isRecent ? coordinator.state?.cart || window.cart || null : null,
          inFlight: coordinator.state?.inFlight || cleanCartTrackedAddPromise,
          isRecent,
        };
      },
      openDrawer: openCleanCartDrawer,
      closeDrawer: closeCleanCartDrawer,
    };

    document.dispatchEvent(new CustomEvent('clean:cart:ready', { detail: { cart: window.CleanCart } }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-cart"]) return;
  try {
    
  (() => {
    const escapeCleanCartPageHtml = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const cleanCartPageAjaxUrl = (url, fallback) => {
      const rawUrl = url || fallback;

      try {
        const parsedUrl = new URL(rawUrl, window.location.origin);
        const path = parsedUrl.pathname.replace(/\/$/, '');
        parsedUrl.pathname = path.endsWith('.js') ? path : `${path}.js`;
        parsedUrl.search = '';

        return `${parsedUrl.pathname}${parsedUrl.search}`;
      } catch (error) {
        const path = String(rawUrl || fallback || '').replace(/\/$/, '');
        return path.endsWith('.js') ? path : `${path}.js`;
      }
    };

    const cleanCartPageRequest = (url, options = {}) =>
      fetch(url, {
        credentials: 'same-origin',
        ...options,
        headers: {
          Accept: 'application/json',
          'X-Clean-Cart': 'true',
          ...(options.headers || {}),
        },
      });

    const cleanCartPageNormalizeMoneyText = (text) => {
      const wrapper = document.createElement('span');
      wrapper.innerHTML = String(text);

      return (wrapper.textContent || wrapper.innerText || '')
        .replace(/\b(?:Rs\.?|INR)[\s\u00a0]*/gi, '₹')
        .trim();
    };

    const cleanCartPageFormatMoney = (cents, moneyFormat) => {
      const selectedCurrency = window.HadiyahDisplayCurrency?.getCurrency?.();

      if (
        (!selectedCurrency || selectedCurrency === 'INR') &&
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      ) {
        return cleanCartPageNormalizeMoneyText(
          window.Shopify.formatMoney(cents, moneyFormat).replace(/\.00(?!\d)/g, ''),
        );
      }

      const numericAmount = Number(cents || 0) / 100;
      const amountWithCommas = numericAmount.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      const amountNoDecimals = Math.round(numericAmount).toLocaleString('en-IN');
      const placeholderPattern = (name) => new RegExp(['\\{', `\\{\\s*${name}\\s*\\}\\}`].join(''), 'g');
      const format = moneyFormat || `₹${['{', '{ amount }}'].join('')}`;

      return cleanCartPageNormalizeMoneyText(
        format
        .replace(placeholderPattern('amount_with_comma_separator'), amountWithCommas)
        .replace(placeholderPattern('amount_no_decimals'), amountNoDecimals)
        .replace(placeholderPattern('amount'), amountWithCommas)
        .replace(/<[^>]*>/g, '')
      );
    };

    const cleanCartPageSourceCurrency = () =>
      document.querySelector('[data-clean-display-currency-config]')?.dataset.cleanDisplayCurrencySource ||
      document.querySelector('[data-clean-cart-page]')?.dataset.cleanCartSourceCurrency ||
      window.cart?.currency ||
      'INR';

    const cleanCartPageMoneyAttributes = (cents, moneyFormat) => {
      const sourceText = cleanCartPageFormatMoney(cents, moneyFormat);
      return `data-clean-money data-clean-money-minor="${escapeCleanCartPageHtml(
        cents,
      )}" data-clean-money-currency="${escapeCleanCartPageHtml(
        cleanCartPageSourceCurrency(),
      )}" data-clean-money-source-text="${escapeCleanCartPageHtml(
        sourceText,
      )}" data-money-cents="${escapeCleanCartPageHtml(cents)}" data-inr-display="${escapeCleanCartPageHtml(
        sourceText,
      )}"`;
    };

    const cleanSetCartPageMoney = (target, cents, moneyFormat) => {
      if (!target) return;

      const sourceText = cleanCartPageFormatMoney(cents, moneyFormat);
      target.dataset.cleanMoney = '';
      target.dataset.cleanMoneyMinor = String(cents);
      target.dataset.cleanMoneyCurrency = cleanCartPageSourceCurrency();
      target.dataset.cleanMoneySourceText = sourceText;
      target.dataset.moneyCents = String(cents);
      target.dataset.inrDisplay = sourceText;
      target.textContent = sourceText;
      window.CleanDisplayCurrency?.refresh(target);
      window.HadiyahDisplayCurrency?.refresh(target);
    };

    const cleanSetCartPageCompactMoney = (target, cents, { abbreviateThousands = false } = {}) => {
      if (!target) return;

      const rupees = Math.max(0, Number(cents) || 0) / 100;
      const amount =
        abbreviateThousands && rupees >= 1000
          ? `${Number.isInteger(rupees / 1000) ? rupees / 1000 : (rupees / 1000).toFixed(1)}k`
          : Math.round(rupees).toLocaleString('en-IN');
      const sourceText = `₹${amount}`;

      target.dataset.cleanMoney = '';
      target.dataset.cleanMoneyMinor = String(cents);
      target.dataset.cleanMoneyCurrency = cleanCartPageSourceCurrency();
      target.dataset.cleanMoneySourceText = sourceText;
      target.dataset.moneyCents = String(cents);
      target.dataset.inrDisplay = sourceText;
      target.textContent = sourceText;
      window.CleanDisplayCurrency?.refresh(target);
      window.HadiyahDisplayCurrency?.refresh(target);
    };

    const cleanSetCartPageMoneyParts = (target, parts, moneyFormat) => {
      if (!target) return;

      const bindings = [];
      const nodes = parts.map((part) => {
        if (typeof part === 'string') return document.createTextNode(part);
        const money = document.createElement('span');
        bindings.push([money, part.money]);
        return money;
      });

      target.replaceChildren(...nodes);
      bindings.forEach(([money, value]) => cleanSetCartPageMoney(money, value, moneyFormat));
    };

    const cleanCartPageQuantity = (value) => {
      const quantity = Number.parseInt(value, 10);
      return Number.isFinite(quantity) ? Math.max(0, quantity) : 0;
    };

    const getCleanCartPageImageUrl = (source, width = 220) => {
      if (!source) return '';

      try {
        const imageUrl = new URL(source, window.location.origin);
        const hostname = imageUrl.hostname.toLowerCase();
        const isShopifyImage =
          hostname === window.location.hostname.toLowerCase() ||
          hostname === 'cdn.shopify.com' ||
          hostname.endsWith('.myshopify.com') ||
          hostname.endsWith('.shopifycdn.com');

        if (isShopifyImage) imageUrl.searchParams.set('width', String(width));
        return imageUrl.toString();
      } catch (error) {
        return String(source);
      }
    };

    const cleanCartPageNormalizePrice = (value) => {
      const price = Number(value);
      return Number.isFinite(price) ? Math.max(0, price) : 0;
    };

    const cleanCartPageHasDiscount = (item = {}) => {
      if (cleanCartPageNormalizePrice(item.total_discount) > 0) return true;
      return (item.discount_allocations || item.line_level_discount_allocations || []).some(
        (allocation) => cleanCartPageNormalizePrice(allocation?.amount) > 0,
      );
    };

    const cleanCartPageLinePrice = (item = {}) => {
      const finalLinePrice = cleanCartPageNormalizePrice(item.final_line_price);
      if (finalLinePrice > 0) return finalLinePrice;

      const linePrice = cleanCartPageNormalizePrice(item.line_price);
      if (linePrice > 0) return linePrice;

      const quantity = cleanCartPageQuantity(item.quantity || 1) || 1;
      const unitPrice = cleanCartPageNormalizePrice(item.final_price || item.price);
      if (unitPrice > 0) return unitPrice * quantity;

      const originalLinePrice = cleanCartPageNormalizePrice(item.original_line_price);
      if (!cleanCartPageHasDiscount(item) && originalLinePrice > 0) return originalLinePrice;

      return 0;
    };

    const cleanCartPageHasUnexpectedZeroPrice = (item = {}) =>
      cleanCartPageQuantity(item.quantity) > 0 &&
      cleanCartPageLinePrice(item) === 0 &&
      !cleanCartPageHasDiscount(item);

    const cleanCartPageRewardMilestones = [
      { amount: 200000, discount: 10000 },
      { amount: 500000, discount: 25000 },
      { amount: 750000, discount: 35000 },
      { amount: 1000000, discount: 50000 },
    ];
    const cleanCartPageRewardMaximum =
      cleanCartPageRewardMilestones[cleanCartPageRewardMilestones.length - 1].amount;

    const updateCleanCartPageRewards = (cartPage, cart = {}) => {
      const rewards = cartPage.querySelector('[data-clean-cart-page-rewards]');
      if (!rewards) return;

      const cartTotal = cleanCartPageNormalizePrice(cart.total_price ?? cartPage.dataset.cleanCartTotalCents);
      const configuredShippingThreshold = cleanCartPageNormalizePrice(
        cartPage.dataset.cleanCartFreeShippingThreshold,
      );
      const shippingThreshold = configuredShippingThreshold || 49900;
      const hasFreeShipping = cartTotal >= shippingThreshold;
      const nextReward = cleanCartPageRewardMilestones.find((milestone) => cartTotal < milestone.amount) || null;
      const nextMarkerAmount = hasFreeShipping ? nextReward?.amount : shippingThreshold;
      const progress = Math.min(100, Math.max(0, (cartTotal * 100) / cleanCartPageRewardMaximum));
      const progressTarget = rewards.querySelector('[data-clean-cart-page-rewards-progress]');
      const fill = rewards.querySelector('[data-clean-cart-page-rewards-fill]');
      const truck = rewards.querySelector('[data-clean-cart-page-rewards-truck]');
      const detail = rewards.querySelector('[data-clean-cart-page-rewards-detail]');

      cartPage.dataset.cleanCartTotalCents = String(cartTotal);
      progressTarget?.setAttribute('aria-valuenow', String(Math.round(progress)));
      if (fill) fill.style.width = `${progress}%`;
      if (truck) truck.style.left = `${progress}%`;

      rewards.querySelectorAll('[data-clean-cart-page-reward-marker]').forEach((marker) => {
        const isShippingMarker = marker.dataset.cleanCartPageRewardAmount === 'shipping';
        const markerAmount = isShippingMarker
          ? shippingThreshold
          : cleanCartPageNormalizePrice(marker.dataset.cleanCartPageRewardAmount);
        const markerPosition = Math.min(100, Math.max(0, (markerAmount * 100) / cleanCartPageRewardMaximum));
        const unlocked = cartTotal >= markerAmount;

        if (isShippingMarker) marker.style.left = `${markerPosition}%`;
        marker.classList.toggle('clean-main-cart__reward-marker--unlocked', unlocked);
        marker.classList.toggle('clean-main-cart__reward-marker--next', !unlocked && markerAmount === nextMarkerAmount);
      });

      rewards.querySelectorAll('[data-clean-cart-page-reward-discount]').forEach((label) => {
        cleanSetCartPageCompactMoney(label, label.dataset.cleanCartPageRewardDiscount);
      });
      rewards.querySelectorAll('[data-clean-cart-page-reward-spend]').forEach((label) => {
        cleanSetCartPageCompactMoney(label, label.dataset.cleanCartPageRewardSpend, { abbreviateThousands: true });
      });

      const rewardsComplete = hasFreeShipping && !nextReward;
      rewards.classList.toggle('clean-main-cart__rewards--complete', rewardsComplete);

      if (!detail) return;
      if (!hasFreeShipping) {
        cleanSetCartPageMoneyParts(
          detail,
          [
            'Add ',
            { money: Math.max(100, Math.ceil((shippingThreshold - cartTotal) / 100) * 100) },
            ' more for free delivery',
          ],
          cartPage.dataset.cleanCartMoneyFormat,
        );
      } else if (nextReward) {
        cleanSetCartPageMoneyParts(
          detail,
          [
            'Add ',
            { money: Math.max(100, Math.ceil((nextReward.amount - cartTotal) / 100) * 100) },
            ' more → unlock ',
            { money: nextReward.discount },
            ' off',
          ],
          cartPage.dataset.cleanCartMoneyFormat,
        );
      } else {
        detail.textContent = 'All rewards unlocked!';
      }
    };
    window.CleanGokwik =
      window.CleanGokwik ||
      (() => {
        const state = {
          countryPromise: null,
          scriptPromise: null,
        };

        const readDetectedCountry = async () => {
          if (state.countryPromise) return state.countryPromise;

          state.countryPromise = (async () => {
            try {
              const cachedCountry = sessionStorage.getItem('cleanGokwikCountry');
              if (cachedCountry) return cachedCountry;

              const response = await fetch('/browsing_context_suggestions.json', {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
              });
              if (!response.ok) return '';

              const data = await response.json();
              const detected = data?.detected_values || {};
              const country =
                detected.country_code ||
                detected.country?.iso_code ||
                detected.country?.handle ||
                (detected.country_name === 'India' ? 'IN' : detected.country_name || '');
              const normalizedCountry = String(country || '').toUpperCase();

              sessionStorage.setItem('cleanGokwikCountry', normalizedCountry);
              return normalizedCountry;
            } catch (error) {
              return '';
            }
          })();

          return state.countryPromise;
        };

        const scriptHostForEnv = (environment) => {
          const normalizedEnvironment = environment || 'production';
          if (normalizedEnvironment === 'production') return 'pdp.gokwik.co';
          if (normalizedEnvironment === 'sandbox') return 'sandbox.pdp.gokwik.co';
          return 'qa.pdp.gokwik.co';
        };

        const loadSdk = (scope) => {
          if (typeof window.onCheckoutClick === 'function') {
            return Promise.resolve();
          }
          if (state.scriptPromise) return state.scriptPromise;

          window.merchantInfo = {
            mid: scope.dataset.cleanGokwikMid || '',
            environment: scope.dataset.cleanGokwikEnv || 'production',
            type: 'merchantInfo',
            storeId: scope.dataset.cleanGokwikStoreId || '',
            fbpixel: scope.dataset.cleanGokwikFbpixel || '',
          };
          window.productFormSelector = window.productFormSelector || '';
          window.templateName =
            window.templateName || (scope.matches('[data-clean-cart-page]') ? 'cart' : 'product');

          state.scriptPromise = new Promise((resolve, reject) => {
            let isSettled = false;
            const scriptUrl = `https://${scriptHostForEnv(scope.dataset.cleanGokwikEnv)}/merchant-integration/build/merchant.integration.js?v4`;
            const existingScript =
              document.getElementById('gokwik-merchant-integration') ||
              document.querySelector(
                '[data-clean-gokwik-sdk], script[src*="merchant-integration/build/merchant.integration.js"]',
              );
            let readyTimer = null;
            let readyTimeout = null;
            const cleanup = () => {
              window.clearInterval(readyTimer);
              window.clearTimeout(readyTimeout);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
            };
            const finish = () => {
              if (isSettled || typeof window.onCheckoutClick !== 'function') return;
              isSettled = true;
              cleanup();
              resolve();
            };
            const fail = (message = 'GoKwik checkout is not ready yet.') => {
              if (isSettled) return;
              isSettled = true;
              cleanup();
              state.scriptPromise = null;
              reject(new Error(message));
            };

            document.addEventListener('gokwikLoaded', finish);
            window.addEventListener('gokwikLoaded', finish);
            readyTimer = window.setInterval(finish, 100);
            readyTimeout = window.setTimeout(() => fail(), 8000);

            if (existingScript) {
              existingScript.id = 'gokwik-merchant-integration';
              existingScript.setAttribute('data-hadiyah-tp-ok', '1');
              existingScript.dataset.cleanGokwikSdk = 'true';
              existingScript.addEventListener('error', () => fail('Unable to load GoKwik checkout.'), {
                once: true,
              });
              if (!existingScript.getAttribute('src')) {
                existingScript.removeAttribute('type');
                existingScript.removeAttribute('data-hadiyah-tp-deferred');
                existingScript.src = scriptUrl;
              }
              finish();
              return;
            }

            const script = document.createElement('script');
            script.id = 'gokwik-merchant-integration';
            script.setAttribute('data-hadiyah-tp-ok', '1');
            script.defer = true;
            script.dataset.cleanGokwikSdk = 'true';
            script.src = scriptUrl;
            script.onload = () => {
              window.setTimeout(finish, 0);
            };
            script.onerror = () => fail('Unable to load GoKwik checkout.');
            document.head.appendChild(script);
          });

          return state.scriptPromise;
        };

        const setScopeVisibility = (scope, useGokwik) => {
          const gokwikButton = scope.querySelector('[data-clean-gokwik-checkout]');
          const shopifyCheckout = scope.querySelector('[data-clean-shopify-checkout]');
          const gokwikReady = useGokwik && typeof window.onCheckoutClick === 'function';

          if (!gokwikReady || !gokwikButton) {
            if (shopifyCheckout) shopifyCheckout.hidden = false;
            if (!gokwikButton) return;

            gokwikButton.hidden = true;
            gokwikButton.setAttribute('aria-hidden', 'true');
            return;
          }

          gokwikButton.hidden = false;
          gokwikButton.setAttribute('aria-hidden', 'false');
          if (shopifyCheckout) shopifyCheckout.hidden = true;
        };

        const getScopeCountry = (scope) => String(scope?.dataset.cleanGokwikCountry || '').toUpperCase();

        const isGokwikCountry = (country) => country === 'IN' || country === 'INDIA';

        const syncScope = async (scope, { detect = false, prepare = false } = {}) => {
          if (!scope) return false;

          setScopeVisibility(scope, false);
          if (scope.dataset.cleanGokwikEnabled !== 'true') return false;

          const selectedCountry = getScopeCountry(scope);
          if (!isGokwikCountry(selectedCountry)) return false;

          const sdkReadyPromise = prepare
            ? loadSdk(scope)
                .then(() => true)
                .catch(() => false)
            : Promise.resolve(typeof window.onCheckoutClick === 'function');
          const detectedCountry = detect ? await readDetectedCountry() : selectedCountry;

          if (!isGokwikCountry(detectedCountry)) return false;

          const sdkReady = await sdkReadyPromise;
          const useGokwik = sdkReady && typeof window.onCheckoutClick === 'function';
          setScopeVisibility(scope, useGokwik);

          return useGokwik;
        };

        const fallbackToShopify = (scope, reason) => {
          if (scope) setScopeVisibility(scope, false);

          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'gokwik_fallback_used',
              path: window.location.pathname,
              reason,
            });
          } catch (error) {}

          const shopifyCheckout = scope?.querySelector('[data-clean-shopify-checkout]');
          const checkoutUrl =
            shopifyCheckout?.getAttribute('href') || scope?.dataset.cleanCartCheckoutUrl || '/checkout';
          window.location.assign(checkoutUrl);
          return false;
        };

        const checkout = async (button, scope) => {
          try {
            if (!scope || scope.dataset.cleanGokwikEnabled !== 'true') {
              return fallbackToShopify(scope, 'scope_unavailable');
            }

            const useGokwik = await syncScope(scope, { detect: true, prepare: true });
            if (!useGokwik || typeof window.onCheckoutClick !== 'function') {
              return fallbackToShopify(scope, 'checkout_not_ready');
            }

            try {
              window.onCheckoutClick(button);
              return true;
            } catch (error) {
              return fallbackToShopify(scope, 'checkout_handler_threw');
            }
          } catch (error) {
            return fallbackToShopify(scope, 'checkout_exception');
          }
        };

        return { checkout, fallbackToShopify, syncScope };
      })();

    const setCleanCartPageStatus = (cartPage, message = '') => {
      const status = cartPage.querySelector('[data-clean-cart-page-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const cleanCartPageToolTitles = {
      instructions: 'Special Instructions',
      'gift-wrap': 'Gift Wrap',
      card: 'Card',
    };

    const cleanCartPageToolDescriptions = {
      instructions: 'Tell us anything that will help us prepare your order just right.',
      'gift-wrap': 'Make your gift feel even more special.',
      card: 'Write a thoughtful note for someone special.',
    };

    const cleanCartPageToolAttributes = (attributes) => {
      if (Array.isArray(attributes)) {
        return Object.fromEntries(
          attributes
            .filter((attribute) => attribute && attribute.key)
            .map((attribute) => [String(attribute.key), String(attribute.value ?? '')]),
        );
      }

      if (!attributes || typeof attributes !== 'object') return {};

      return Object.fromEntries(
        Object.entries(attributes).map(([key, value]) => [String(key), String(value ?? '')]),
      );
    };

    const cleanCartPageToolFallbackCart = (cartPage) => ({
      item_count: cartPage.querySelectorAll('[data-clean-cart-page-item]').length,
      note: cartPage.dataset.cleanCartNote || '',
      attributes: {
        To: cartPage.dataset.cleanCartCardTo || '',
        From: cartPage.dataset.cleanCartCardFrom || '',
        Message: cartPage.dataset.cleanCartCardMessage || '',
      },
      items: [],
    });

    const cleanCartPageToolHasItems = (cart) =>
      Number(cart?.item_count || 0) > 0 ||
      (Array.isArray(cart?.items) && cart.items.some((item) => Number(item?.quantity || 0) > 0));

    const cleanCartPageGiftWrapHandle = (cartPage) =>
      String(cartPage.dataset.cleanCartGiftWrapHandle || 'gift-wrap')
        .trim()
        .toLowerCase();

    const cleanCartPageGiftWrapVariantId = (cartPage) =>
      String(cartPage.dataset.cleanCartGiftWrapVariantId || '').trim();

    const cleanCartPageGiftWrapItem = (cartPage, cart) => {
      const handle = cleanCartPageGiftWrapHandle(cartPage);
      const variantId = cleanCartPageGiftWrapVariantId(cartPage);
      return (cart?.items || []).find((item) => {
        if (
          variantId &&
          (String(item?.id || '').trim() === variantId ||
            String(item?.variant_id || '').trim() === variantId)
        ) {
          return true;
        }

        const itemHandle = String(item?.handle || item?.product_handle || '')
          .trim()
          .toLowerCase();
        const itemUrl = String(item?.url || '').toLowerCase();
        return itemHandle === handle || itemUrl.includes(`/products/${handle}`);
      });
    };

    const cleanCartPageToolDrafts = (cartPage, cart) => {
      const fallback = cleanCartPageToolFallbackCart(cartPage);
      const source = cart || fallback;
      const attributes = cleanCartPageToolAttributes(source.attributes);
      const getAttribute = (name, legacyName) =>
        attributes[name] || attributes[legacyName] || '';

      return {
        note: String(source.note ?? fallback.note ?? ''),
        to: String(getAttribute('To', 'Card To') || fallback.attributes.To || ''),
        from: String(getAttribute('From', 'Card From') || fallback.attributes.From || ''),
        message: String(getAttribute('Message', 'Card Message') || fallback.attributes.Message || ''),
      };
    };

    const setCleanCartPageToolsStatus = (cartPage, message = '') => {
      const status = cartPage.querySelector('[data-clean-cart-tools-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const updateCleanCartPageTools = (cartPage, cart) => {
      const hasItems = cleanCartPageToolHasItems(cart);
      const giftWrapItem = cleanCartPageGiftWrapItem(cartPage, cart);
      const giftWrapVariant = cartPage.cleanCartGiftWrapVariant;

      cartPage.querySelectorAll('[data-clean-cart-tool]').forEach((button) => {
        const tool = button.dataset.cleanCartTool;
        button.disabled = !hasItems;

        if (tool !== 'gift-wrap') return;

        const subtext = button.querySelector('[data-clean-cart-tool-subtext="gift-wrap"]');
        if (!subtext) return;

        subtext.textContent = giftWrapItem
          ? 'Gift wrap added — manage it here'
          : giftWrapVariant === null
            ? 'Gift wrap is currently unavailable'
            : 'Make your gift feel extra special';
      });
    };

    const setCleanCartPageToolDialogStatus = (dialog, message = '', isError = false) => {
      const status = dialog.querySelector('[data-clean-cart-tool-form-status]');
      if (!status) return;

      status.textContent = message;
      status.dataset.error = isError ? 'true' : 'false';
      status.hidden = !message;
    };

    const setCleanCartPageToolDialogBusy = (dialog, busy) => {
      const state = dialog.closest('[data-clean-cart-page]')?.cleanCartPageToolsState;
      if (state) state.busy = busy;

      dialog.setAttribute('aria-busy', busy ? 'true' : 'false');
      dialog.querySelectorAll('button, textarea').forEach((control) => {
        if (control.matches('[data-clean-cart-tool-close]')) {
          control.disabled = busy;
          return;
        }

        control.disabled = busy || control.dataset.cleanCartToolUnavailable === 'true';
      });
    };

    const renderCleanCartPageToolActions = (submitLabel, pendingLabel, submitDisabled = false) => `
      <div class="clean-main-cart__tool-actions">
        <button
          class="clean-main-cart__tool-action"
          type="submit"
          data-clean-cart-tool-submit
          data-clean-cart-tool-original-label="${escapeCleanCartPageHtml(submitLabel)}"
          data-clean-cart-tool-pending-label="${escapeCleanCartPageHtml(pendingLabel)}"
          ${submitDisabled ? "data-clean-cart-tool-unavailable='true' disabled" : ''}
        >${escapeCleanCartPageHtml(submitLabel)}</button>
        <button class="clean-main-cart__tool-action clean-main-cart__tool-action--secondary" type="button" data-clean-cart-tool-cancel>Cancel</button>
        <p class="clean-main-cart__tool-form-status" data-clean-cart-tool-form-status role="status" aria-live="polite" hidden></p>
      </div>
    `;

    const renderCleanCartPageToolLoading = (dialog, tool = 'gift-wrap') => {
      dialog.querySelector('[data-clean-cart-tool-dialog-title]').textContent = cleanCartPageToolTitles[tool];
      dialog.querySelector('[data-clean-cart-tool-dialog-description]').textContent = cleanCartPageToolDescriptions[tool];
      dialog.querySelector('[data-clean-cart-tool-dialog-content]').innerHTML =
        '<p class="clean-main-cart__tool-loading">Checking cart options…</p>';
    };

    const renderCleanCartPageToolDialog = (dialog, tool, cart, giftWrapVariant, errorMessage = '') => {
      const content = dialog.querySelector('[data-clean-cart-tool-dialog-content]');
      const drafts = cleanCartPageToolDrafts(dialog.closest('[data-clean-cart-page]'), cart);
      const escapedNote = escapeCleanCartPageHtml(drafts.note);
      const escapedTo = escapeCleanCartPageHtml(drafts.to);
      const escapedFrom = escapeCleanCartPageHtml(drafts.from);
      const escapedMessage = escapeCleanCartPageHtml(drafts.message);

      dialog.querySelector('[data-clean-cart-tool-dialog-title]').textContent = cleanCartPageToolTitles[tool];
      dialog.querySelector('[data-clean-cart-tool-dialog-description]').textContent =
        cleanCartPageToolDescriptions[tool];

      if (tool === 'instructions') {
        content.innerHTML = `
          <form class="clean-main-cart__tool-form" data-clean-cart-tool-form data-clean-cart-tool-form-type="instructions">
            <div class="clean-main-cart__tool-field">
              <label for="clean-main-cart-special-instructions">Order special instructions</label>
              <textarea id="clean-main-cart-special-instructions" name="note" rows="5" data-clean-cart-tool-autofocus placeholder="Order special instructions">${escapedNote}</textarea>
            </div>
            ${renderCleanCartPageToolActions('Save Instructions', 'Saving instructions…')}
          </form>
        `;
      } else if (tool === 'card') {
        content.innerHTML = `
          <form class="clean-main-cart__tool-form" data-clean-cart-tool-form data-clean-cart-tool-form-type="card">
            <div class="clean-main-cart__tool-field">
              <label for="clean-main-cart-card-to">To</label>
              <textarea id="clean-main-cart-card-to" name="to" rows="2" data-clean-cart-tool-autofocus placeholder="Enter recipient name">${escapedTo}</textarea>
            </div>
            <div class="clean-main-cart__tool-field">
              <label for="clean-main-cart-card-from">From</label>
              <textarea id="clean-main-cart-card-from" name="from" rows="2" placeholder="Enter sender name">${escapedFrom}</textarea>
            </div>
            <div class="clean-main-cart__tool-field">
              <label for="clean-main-cart-card-message">Message</label>
              <textarea id="clean-main-cart-card-message" name="message" rows="4" placeholder="Enter a message">${escapedMessage}</textarea>
            </div>
            ${renderCleanCartPageToolActions('Save Card', 'Saving card message…')}
          </form>
        `;
      } else {
        const cartPage = dialog.closest('[data-clean-cart-page]');
        const giftWrapItem = cleanCartPageGiftWrapItem(cartPage, cart);
        const hasGiftWrap = Boolean(giftWrapItem);
        const canSubmit = hasGiftWrap || Boolean(giftWrapVariant?.available);
        const submitLabel = hasGiftWrap ? 'Remove Gift Wrap' : 'Add Gift Wrap';
        const pendingLabel = hasGiftWrap ? 'Removing gift wrap…' : 'Adding gift wrap…';
        const copy = errorMessage ||
          (hasGiftWrap
            ? 'Gift wrap is already included. You can remove it here if you change your mind.'
            : canSubmit
              ? 'Add gift wrap to make your present feel extra special.'
              : 'Gift wrap is currently unavailable. Please try again later.');

        content.innerHTML = `
          <form class="clean-main-cart__tool-gift-wrap" data-clean-cart-tool-form data-clean-cart-tool-form-type="gift-wrap" data-clean-cart-tool-action="${hasGiftWrap ? 'remove' : 'add'}">
            <span class="clean-main-cart__tool-gift-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24"><path d="M4 10h16v11H4zM3 7h18v3H3zM12 7v14M12 7H8.5A2.5 2.5 0 1 1 12 4.5zM12 7h3.5A2.5 2.5 0 1 0 12 4.5z"></path></svg>
            </span>
            <p class="clean-main-cart__tool-gift-copy">${escapeCleanCartPageHtml(copy)}</p>
            ${renderCleanCartPageToolActions(submitLabel, pendingLabel, !canSubmit)}
          </form>
        `;
      }

      setCleanCartPageToolDialogStatus(dialog, errorMessage, Boolean(errorMessage));
    };

    const cleanCartPageToolProductUrl = (cartPage) => {
      const rootUrl = new URL(cartPage.dataset.cleanCartRootUrl || '/', window.location.origin);
      const rootPath = rootUrl.pathname.replace(/\/$/, '');
      const handle = encodeURIComponent(cleanCartPageGiftWrapHandle(cartPage));
      return `${rootPath}/products/${handle}.js`;
    };

    const loadCleanCartPageGiftWrapVariant = async (cartPage) => {
      if (Object.prototype.hasOwnProperty.call(cartPage, 'cleanCartGiftWrapVariant')) {
        return cartPage.cleanCartGiftWrapVariant;
      }

      const configuredVariantId = cleanCartPageGiftWrapVariantId(cartPage);
      if (configuredVariantId) {
        cartPage.cleanCartGiftWrapVariant = { id: configuredVariantId, available: true };
        return cartPage.cleanCartGiftWrapVariant;
      }

      if (cartPage.cleanCartGiftWrapVariantPromise) {
        return cartPage.cleanCartGiftWrapVariantPromise;
      }

      cartPage.cleanCartGiftWrapVariantPromise = cleanCartPageRequest(cleanCartPageToolProductUrl(cartPage))
        .then(async (response) => {
          if (!response.ok) throw new Error('Gift wrap is currently unavailable.');
          const product = await response.json();
          const variant = (product.variants || []).find((item) => item.available) || null;
          cartPage.cleanCartGiftWrapVariant = variant;
          return variant;
        })
        .catch((error) => {
          delete cartPage.cleanCartGiftWrapVariantPromise;
          throw error;
        });

      return cartPage.cleanCartGiftWrapVariantPromise;
    };

    const getCleanCartPageRequestError = async (response, fallback) => {
      const payload = await response.json().catch(() => ({}));
      const errors = Array.isArray(payload?.errors) ? payload.errors : [];
      const firstError = errors.find((error) => error);
      const message =
        payload?.description ||
        payload?.message ||
        (typeof firstError === 'string' ? firstError : firstError?.message) ||
        fallback;
      return String(message);
    };

    const postCleanCartPageToolJson = async (cartPage, url, payload, fallback) => {
      const response = await cleanCartPageRequest(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(await getCleanCartPageRequestError(response, fallback));
      }

      return response.json();
    };

    const postCleanCartPageToolForm = async (cartPage, url, entries, fallback) => {
      const body = new FormData();
      Object.entries(entries).forEach(([name, value]) => body.append(name, value || ''));

      const response = await cleanCartPageRequest(url, {
        method: 'POST',
        body,
      });

      if (!response.ok) {
        throw new Error(await getCleanCartPageRequestError(response, fallback));
      }

      return response.json();
    };

    const refreshCleanCartPageAfterToolMutation = async (cartPage) => {
      const cart = await fetchCleanCartPage(cartPage);
      window.CleanCartState?.publish?.(cart);
      document.dispatchEvent(
        new CustomEvent('clean:cart:updated', {
          detail: { cart, origin: 'clean-main-cart-tools' },
        }),
      );
      return cart;
    };

    const submitCleanCartPageTool = async (cartPage, dialog, form) => {
      const type = form.dataset.cleanCartToolFormType;
      let cart = await refreshCleanCartPageAfterToolMutation(cartPage);

      if (!cleanCartPageToolHasItems(cart)) {
        window.location.assign(cartPage.dataset.cleanCartUrl || '/cart');
        return '';
      }

      if (type === 'instructions') {
        const note = String(form.elements.note?.value || '');
        await postCleanCartPageToolForm(
          cartPage,
          cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUpdateUrl, '/cart/update'),
          { note },
          'Unable to save special instructions.',
        );
        cart = await refreshCleanCartPageAfterToolMutation(cartPage);
        return 'Special instructions saved.';
      }

      if (type === 'card') {
        const attributes = cleanCartPageToolAttributes(cart.attributes);
        attributes.To = String(form.elements.to?.value || '');
        attributes.From = String(form.elements.from?.value || '');
        attributes.Message = String(form.elements.message?.value || '');
        await postCleanCartPageToolForm(
          cartPage,
          cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUpdateUrl, '/cart/update'),
          {
            'attributes[To]': attributes.To,
            'attributes[From]': attributes.From,
            'attributes[Message]': attributes.Message,
            'attributes[Card To]': '',
            'attributes[Card From]': '',
            'attributes[Card Message]': '',
          },
          'Unable to save the card message.',
        );
        cart = await refreshCleanCartPageAfterToolMutation(cartPage);
        return 'Card message saved.';
      }

      const giftWrapItem = cleanCartPageGiftWrapItem(cartPage, cart);
      if (form.dataset.cleanCartToolAction === 'remove') {
        if (giftWrapItem?.key) {
          await postCleanCartPageToolJson(
            cartPage,
            cleanCartPageAjaxUrl(cartPage.dataset.cleanCartChangeUrl, '/cart/change'),
            { id: giftWrapItem.key, quantity: 0 },
            'Unable to remove gift wrap.',
          );
          cart = await refreshCleanCartPageAfterToolMutation(cartPage);
        }
        return 'Gift wrap removed from your cart.';
      }

      if (giftWrapItem) return 'Gift wrap is already included in your cart.';

      const variant = await loadCleanCartPageGiftWrapVariant(cartPage);
      if (!variant?.available) {
        throw new Error('Gift wrap is currently unavailable. Please try again later.');
      }

      await postCleanCartPageToolJson(
        cartPage,
        cleanCartPageAjaxUrl(cartPage.dataset.cleanCartAddUrl, '/cart/add'),
        { id: variant.id, quantity: 1 },
        'Unable to add gift wrap.',
      );
      cart = await refreshCleanCartPageAfterToolMutation(cartPage);
      return 'Gift wrap added to your cart.';
    };

    const initCleanCartPageTools = (cartPage, lifecycle) => {
      const tools = cartPage.querySelector('[data-clean-cart-tools]');
      const dialog = cartPage.querySelector('[data-clean-cart-tool-dialog]');
      if (!tools || !dialog || tools.dataset.cleanCartToolsReady === 'true') return;

      tools.dataset.cleanCartToolsReady = 'true';
      cartPage.cleanCartPageToolsState = { busy: false, openToken: null, restoreFocus: null };
      updateCleanCartPageTools(cartPage, window.cart || cleanCartPageToolFallbackCart(cartPage));

      const getState = () => cartPage.cleanCartPageToolsState;

      const syncToolDialogViewport = () => {
        if (!dialog.open) return;

        const visualViewport = window.visualViewport;
        const visualHeight = Math.max(0, visualViewport?.height || window.innerHeight);
        const visualOffsetTop = Math.max(0, visualViewport?.offsetTop || 0);
        const keyboardInset = Math.max(0, window.innerHeight - visualHeight - visualOffsetTop);

        dialog.style.setProperty('--clean-main-cart-tool-viewport-height', `${visualHeight}px`);
        dialog.style.setProperty('--clean-main-cart-tool-keyboard-inset', `${keyboardInset}px`);
      };

      const resetToolDialogViewport = () => {
        dialog.style.removeProperty('--clean-main-cart-tool-viewport-height');
        dialog.style.removeProperty('--clean-main-cart-tool-keyboard-inset');
      };

      const closeDialog = () => {
        const state = getState();
        if (state.busy) return;
        state.openToken = null;
        if (dialog.open) dialog.close();
      };

      dialog.querySelector('[data-clean-cart-tool-close]')?.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          closeDialog();
        },
        { signal: lifecycle.signal },
      );

      window.addEventListener('resize', syncToolDialogViewport, { signal: lifecycle.signal });
      window.visualViewport?.addEventListener('resize', syncToolDialogViewport, {
        signal: lifecycle.signal,
      });
      window.visualViewport?.addEventListener('scroll', syncToolDialogViewport, {
        signal: lifecycle.signal,
      });

      tools.addEventListener(
        'click',
        async (event) => {
          const button = event.target.closest('[data-clean-cart-tool]');
          if (!button || !tools.contains(button) || button.disabled) return;

          event.preventDefault();
          const tool = button.dataset.cleanCartTool;
          const state = getState();
          if (!tool || state.busy || dialog.open) return;

          state.openToken = {};
          const token = state.openToken;
          state.restoreFocus = button;
          setCleanCartPageToolsStatus(cartPage, '');
          renderCleanCartPageToolLoading(dialog, tool);
          dialog.dataset.cleanCartTool = tool;
          dialog.showModal();
          syncToolDialogViewport();

          try {
            let cart = window.cart;
            if (!cart || !Array.isArray(cart.items)) {
              cart = await fetchCleanCartPage(cartPage);
            }
            if (state.openToken !== token || !dialog.open) return;

            if (!cleanCartPageToolHasItems(cart)) {
              closeDialog();
              return;
            }

            let giftWrapVariant;
            if (tool === 'gift-wrap' && !cleanCartPageGiftWrapItem(cartPage, cart)) {
              try {
                giftWrapVariant = await loadCleanCartPageGiftWrapVariant(cartPage);
              } catch (error) {
                giftWrapVariant = null;
              }
            } else {
              giftWrapVariant = cartPage.cleanCartGiftWrapVariant;
            }

            if (state.openToken !== token || !dialog.open) return;
            renderCleanCartPageToolDialog(dialog, tool, cart, giftWrapVariant);
            requestAnimationFrame(() => {
              dialog.querySelector('[data-clean-cart-tool-autofocus]')?.focus({ preventScroll: true });
            });
          } catch (error) {
            if (state.openToken !== token || !dialog.open) return;
            renderCleanCartPageToolDialog(
              dialog,
              tool,
              window.cart || cleanCartPageToolFallbackCart(cartPage),
              null,
              error?.message || 'Unable to load this cart option.',
            );
          }
        },
        { signal: lifecycle.signal },
      );

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
        if (event.target.closest('[data-clean-cart-tool-close], [data-clean-cart-tool-cancel]')) {
          closeDialog();
        }
      }, { signal: lifecycle.signal });

      dialog.addEventListener('cancel', (event) => {
        if (getState().busy) event.preventDefault();
      }, { signal: lifecycle.signal });

      dialog.addEventListener('close', () => {
        const state = getState();
        state.openToken = null;
        state.busy = false;
        dialog.removeAttribute('aria-busy');
        resetToolDialogViewport();
        const restoreFocus = state.restoreFocus;
        state.restoreFocus = null;
        if (restoreFocus?.isConnected && !restoreFocus.disabled) {
          restoreFocus.focus({ preventScroll: true });
        }
      }, { signal: lifecycle.signal });

      dialog.addEventListener('submit', async (event) => {
        const form = event.target.closest('[data-clean-cart-tool-form]');
        if (!form || !dialog.contains(form)) return;

        event.preventDefault();
        const state = getState();
        if (state.busy) return;

        setCleanCartPageToolDialogBusy(dialog, true);
        const submit = form.querySelector('[data-clean-cart-tool-submit]');
        const originalLabel = submit?.dataset.cleanCartToolOriginalLabel || submit?.textContent || '';
        const pendingLabel = submit?.dataset.cleanCartToolPendingLabel || 'Saving…';
        if (submit) submit.textContent = pendingLabel;
        setCleanCartPageToolDialogStatus(dialog, pendingLabel);

        try {
          const message = await submitCleanCartPageTool(cartPage, dialog, form);
          updateCleanCartPageTools(cartPage, window.cart || cleanCartPageToolFallbackCart(cartPage));
          setCleanCartPageToolsStatus(cartPage, message);
          if (dialog.open) dialog.close();
        } catch (error) {
          setCleanCartPageToolDialogBusy(dialog, false);
          if (submit) submit.textContent = originalLabel;
          setCleanCartPageToolDialogStatus(
            dialog,
            `${error?.message || 'Unable to save this cart option.'} Your entries are still here; please try again.`,
            true,
          );
        }
      }, { signal: lifecycle.signal });

      lifecycle.signal.addEventListener('abort', () => {
        if (dialog.open) dialog.close();
      }, { once: true });
    };

    const cleanCartPagePropertyStringValue = (value) => (Array.isArray(value) ? value.join(', ') : String(value ?? ''));

    const isCleanCartPagePreviewProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase()
        .startsWith('preview.');

    const getCleanCartPagePreviewUrls = (value) => {
      const values = Array.isArray(value) ? value : [value];
      const urls = [];

      values.forEach((item) => {
        const matches = String(item ?? '').match(/https?:\/\/[^\s,]+/gi) || [];

        matches.forEach((match) => {
          const candidate = match.replace(/^[('"[]+|[)'"\]]+$/g, '');

          try {
            const url = new URL(candidate);
            if ((url.protocol === 'http:' || url.protocol === 'https:') && !urls.includes(url.href)) {
              urls.push(url.href);
            }
          } catch (error) {
            // Ignore malformed preview URLs and fall back to the raw property value below.
          }
        });
      });

      return urls;
    };

    const renderCleanCartPagePreviewControl = (previewUrls = [], item = {}) => {
      const urls = (previewUrls || []).filter(Boolean);
      if (!urls.length) return '';

      const productTitle = String(item.product_title || item.title || '').trim();
      const label = urls.length > 1 ? `View Preview (${urls.length})` : 'View Preview';

      // Put URLs on the button — <script> JSON inside innerHTML is unreliable.
      return `
        <span class="cart-item__custom-preview">
          <button
            type="button"
            class="clean-main-cart__meta-link cart-item__preview-open"
            data-cart-preview-open
            data-cart-preview-urls="${escapeCleanCartPageHtml(urls.join('|'))}"
            data-cart-preview-product="${escapeCleanCartPageHtml(productTitle)}"
            data-cart-preview-product-url="${escapeCleanCartPageHtml(item.url || '')}"
            data-cart-preview-line-key="${escapeCleanCartPageHtml(item.key || '')}"
          >
            ${escapeCleanCartPageHtml(label)}
          </button>
        </span>
      `;
    };

    const renderCleanCartPagePropertyValue = (name, value, item = {}) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      const previewUrls = isCleanCartPagePreviewProperty(name) ? getCleanCartPagePreviewUrls(value) : [];

      if (previewUrls.length) {
        return renderCleanCartPagePreviewControl(previewUrls, item);
      }

      return escapeCleanCartPageHtml(cleanCartPagePropertyStringValue(value));
    };

    const renderCleanCartPagePropertyLabel = (name) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      if (normalizedName === 'preview.effects') return '';
      if (normalizedName === 'preview.texts') return 'Text';
      if (normalizedName === 'preview.images') return 'Photos';
      return name;
    };

    const isCleanCartPageZipcodeProperty = (name) =>
      ['pincode', 'delivery tier', 'delivery estimate', 'delivery speed'].includes(
        String(name || '')
          .trim()
          .toLowerCase(),
      );

    const renderCleanCartPageVariantOptions = (item = {}) => {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const visibleOptions = options.filter((option) => {
        const name = String(option?.name || '').trim();
        const value = String(option?.value || '').trim();
        return name && value && value !== 'Default Title';
      });

      if (visibleOptions.length) {
        return `
          <dl class="clean-main-cart__meta clean-main-cart__meta--variants">
            ${visibleOptions
              .map(
                (option) => `
                  <div class="clean-main-cart__meta-row">
                    <dt>${escapeCleanCartPageHtml(option.name)}:</dt>
                    <dd>${escapeCleanCartPageHtml(option.value)}</dd>
                  </div>
                `,
              )
              .join('')}
          </dl>
        `;
      }

      const variantTitle = String(item.variant_title || '').trim();
      if (!variantTitle || variantTitle === 'Default Title') return '';

      return `
        <dl class="clean-main-cart__meta clean-main-cart__meta--variants">
          <div class="clean-main-cart__meta-row">
            <dt>Variant:</dt>
            <dd>${escapeCleanCartPageHtml(variantTitle)}</dd>
          </div>
        </dl>
      `;
    };

    const renderCleanCartPageProperties = (properties = {}, item = {}) => {
      const entries = Object.entries(properties).filter(([name, value]) => {
        const stringValue = cleanCartPagePropertyStringValue(value);
        return name && !name.startsWith('_') && !isCleanCartPageZipcodeProperty(name) && stringValue.trim() !== '';
      });

      if (!entries.length) return '';

      const visibleEntries = entries.filter(
        ([name]) =>
          ['Delivery Date', 'Delivery Day', 'Delivery Time', 'Name On Cake'].includes(name) ||
          isCleanCartPagePreviewProperty(name),
      );
      const fallbackEntries = visibleEntries.length ? visibleEntries : entries.slice(0, 3);

      return `
        <dl class="clean-main-cart__meta">
          ${fallbackEntries
            .map(([name, value]) => {
              const label = renderCleanCartPagePropertyLabel(name);
              return `
                <div class="clean-main-cart__meta-row">
                  ${label ? `<dt>${escapeCleanCartPageHtml(label)}:</dt>` : ''}
                  <dd>${renderCleanCartPagePropertyValue(name, value, item)}</dd>
                </div>
              `;
            })
            .join('')}
        </dl>
      `;
    };

    const isCleanCartPageAddOnItem = (item = {}) => {
      const properties = item?.properties || {};

      return (
        String(properties['_Add-on upsell'] || '').trim().toLowerCase() === 'yes' ||
        String(properties['_Add-on source'] || '').trim().toLowerCase() === 'post add-to-cart drawer'
      );
    };

    const getCleanWaPersonalizableIds = (cartPage) => {
      try {
        const parsed = JSON.parse(cartPage.dataset.cleanWaPersonalizableIds || '[]');
        return new Set((Array.isArray(parsed) ? parsed : []).map((id) => String(id)));
      } catch (_error) {
        return new Set();
      }
    };

    const cleanWaTplIdFromKey = (key) =>
      String(key || '')
        .replace(/[:?/]/g, '-');

    const isCleanWaPersonalizableItem = (item, personalizableIds) => {
      if (!item) return false;
      if (personalizableIds.has(String(item.product_id || ''))) return true;
      const properties = item.properties || {};
      const nameValue = String(properties.Name || properties.name || '').trim();
      if (nameValue && nameValue !== 'undefined') return true;
      if (String(properties._wa_personalized || '') === '1') return true;
      return Boolean(
        properties['preview.effects'] || properties['preview.images'] || properties['preview.image'],
      );
    };

    const itemHasCleanWaCustomization = (item) => {
      const properties = item?.properties || {};
      const nameValue = String(properties.Name || properties.name || '').trim();
      return Boolean(nameValue && nameValue !== 'undefined');
    };

    const getCleanWaPreviewImage = (item) => {
      const properties = item?.properties || {};
      const preview =
        properties['preview.effects'] || properties['preview.images'] || properties['preview.image'] || '';
      const firstPreview = String(preview)
        .split(',')
        .map((part) => part.trim())
        .find(Boolean);
      return firstPreview || item?.image || '';
    };

    const renderCleanWaCustomizeButton = (item, personalizableIds) => {
      if (!isCleanWaPersonalizableItem(item, personalizableIds)) return '';

      const hasCustomization = itemHasCleanWaCustomization(item);
      const tplId = cleanWaTplIdFromKey(item.key);
      const hiddenAttr = document.documentElement.classList.contains('wa-cart-flow') ? '' : ' hidden';

      return `
        <div class="clean-main-cart__wa-customize" data-wa-personalizable>
          <button
            type="button"
            class="button wa-customize-now-btn"
            data-wa-open-customize
            data-line-key="${escapeCleanCartPageHtml(item.key)}"
            data-line-index="${escapeCleanCartPageHtml(tplId)}"
            data-product-title="${escapeCleanCartPageHtml(item.product_title || item.title)}"
            data-product-image="${escapeCleanCartPageHtml(getCleanWaPreviewImage(item))}"
            data-product-image-alt="${escapeCleanCartPageHtml(item.product_title || item.title)}"
            data-variant-id="${escapeCleanCartPageHtml(item.variant_id || item.id)}"
            data-quantity="${Number(item.quantity || 0)}"
            data-has-customization="${hasCustomization}"
            ${hiddenAttr}
          >
            ${hasCustomization ? 'Edit customization' : 'Customize now'}
          </button>
        </div>
      `;
    };

    const revealCleanWaCustomizeButtons = () => {
      if (!document.documentElement.classList.contains('wa-cart-flow')) return;
      document.querySelectorAll('[data-wa-open-customize]').forEach((btn) => {
        btn.hidden = false;
      });
    };

    const renderCleanCartPage = (cartPage, cart) => {
      const itemsTarget = cartPage.querySelector('[data-clean-cart-page-items]');
      const countTarget = cartPage.querySelector('[data-clean-cart-page-count]');
      const subtotalTarget = cartPage.querySelector('[data-clean-cart-page-subtotal]');
      const totalTarget = cartPage.querySelector('[data-clean-cart-page-total]');
      const checkout = cartPage.querySelector('.clean-main-cart__checkout');
      const gokwikCheckout = cartPage.querySelector('[data-clean-gokwik-checkout]');
      const itemCount = Number(cart?.item_count || 0);

      if (!itemsTarget || !countTarget || !subtotalTarget || !totalTarget) return;

      window.cart = cart;
      updateCleanCartPageRewards(cartPage, cart);

      if (!itemCount) {
        window.location.assign(cartPage.dataset.cleanCartUrl || '/cart');
        return;
      }

      countTarget.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
      cleanSetCartPageMoney(
        subtotalTarget,
        Number(cart?.items_subtotal_price || 0),
        cartPage.dataset.cleanCartMoneyFormat,
      );
      cleanSetCartPageMoney(totalTarget, Number(cart?.total_price || 0), cartPage.dataset.cleanCartMoneyFormat);
      document.querySelectorAll('[data-clean-cart-count]').forEach((target) => {
        target.textContent = String(itemCount);
      });

      [checkout, gokwikCheckout].forEach((target) => {
        if (!target) return;

        if (itemCount === 0) {
          target.setAttribute('aria-disabled', 'true');
        } else {
          target.removeAttribute('aria-disabled');
        }
      });

      const addOnsWereOpen = itemsTarget.querySelector('[data-clean-cart-page-add-ons]')?.open ?? true;
      const ordinaryItems = cart.items.filter((item) => !isCleanCartPageAddOnItem(item));
      const addOnItems = cart.items.filter((item) => isCleanCartPageAddOnItem(item));
      const addOnQuantity = addOnItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
      const waPersonalizableIds = getCleanWaPersonalizableIds(cartPage);
      const renderItem = (item) => {
        const linePrice = cleanCartPageLinePrice(item);
        const compareLinePrice = Number(item.original_line_price || 0);
        const isAddOnItem = isCleanCartPageAddOnItem(item);
        const imageMarkup = item.image
          ? `<img class="clean-main-cart__image" src="${escapeCleanCartPageHtml(
              getCleanCartPageImageUrl(item.image),
            )}" alt="${escapeCleanCartPageHtml(
              item.product_title || item.title,
            )}" width="110" height="110" loading="lazy">`
          : '<span class="clean-main-cart__image clean-main-cart__image--placeholder" aria-hidden="true"></span>';
        const compareMarkup =
          compareLinePrice > linePrice
            ? `<s class="clean-main-cart__compare-price" ${cleanCartPageMoneyAttributes(
                compareLinePrice,
                cartPage.dataset.cleanCartMoneyFormat,
              )}>${escapeCleanCartPageHtml(
                cleanCartPageFormatMoney(compareLinePrice, cartPage.dataset.cleanCartMoneyFormat),
              )}</s>`
            : '';

        return `
            <article class="clean-main-cart__item${
              isAddOnItem ? ' clean-main-cart__item--add-on' : ''
            }" data-clean-cart-page-item="${escapeCleanCartPageHtml(item.key)}">
              <a class="clean-main-cart__image-link" href="${escapeCleanCartPageHtml(
                item.url || '#',
              )}" aria-label="${escapeCleanCartPageHtml(item.title)}">
                ${imageMarkup}
              </a>
              <div class="clean-main-cart__item-body">
                <a class="clean-main-cart__item-title" href="${escapeCleanCartPageHtml(item.url || '#')}">
                  ${escapeCleanCartPageHtml(item.product_title || item.title)}
                </a>
                ${renderCleanCartPageVariantOptions(item)}
                ${renderCleanCartPageProperties(item.properties, item)}
                ${renderCleanWaCustomizeButton(item, waPersonalizableIds)}
                <div class="clean-main-cart__prices">
                  ${compareMarkup}
                  <span class="clean-main-cart__price" ${cleanCartPageMoneyAttributes(
                    linePrice,
                    cartPage.dataset.cleanCartMoneyFormat,
                  )}>${escapeCleanCartPageHtml(
                    cleanCartPageFormatMoney(linePrice, cartPage.dataset.cleanCartMoneyFormat),
                  )}</span>
                </div>
                <div class="clean-main-cart__quantity" data-clean-cart-page-quantity>
                  <button type="button" aria-label="Decrease quantity" data-clean-cart-page-quantity-decrease>-</button>
                  <input
                    type="number"
                    min="0"
                    value="${Number(item.quantity || 0)}"
                    inputmode="numeric"
                    aria-label="Quantity for ${escapeCleanCartPageHtml(item.product_title || item.title)}"
                    data-clean-cart-page-quantity-input
                  >
                  <button type="button" aria-label="Increase quantity" data-clean-cart-page-quantity-increase>+</button>
                </div>
              </div>
              <button class="clean-main-cart__remove" type="button" aria-label="Remove ${escapeCleanCartPageHtml(
                item.product_title || item.title,
              )}" data-clean-cart-page-remove>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3"></path>
                </svg>
              </button>
            </article>
          `;
      };
      const addOnMarkup = addOnItems.map(renderItem).join('');

      itemsTarget.innerHTML = `
        ${ordinaryItems.map(renderItem).join('')}
        ${
          addOnItems.length
            ? `
              <details class="clean-main-cart__add-ons" data-clean-cart-page-add-ons${addOnsWereOpen ? ' open' : ''}>
                <summary class="clean-main-cart__add-ons-summary">
                  <span>Add-ons</span>
                  <span class="clean-main-cart__add-ons-count">${addOnQuantity}</span>
                </summary>
                <div class="clean-main-cart__add-ons-items">
                  ${addOnMarkup}
                </div>
              </details>
            `
            : ''
        }
      `;
      revealCleanWaCustomizeButtons();
    };

    const fetchCleanCartPage = async (cartPage) => {
      const cartUrl = cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUrl, '/cart');
      const loadCart = async () => {
        const response = await cleanCartPageRequest(cartUrl);
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      };
      const cart = window.CleanCartState?.refresh ? await window.CleanCartState.refresh(loadCart) : await loadCart();
      window.CleanCartState?.publish?.(cart);
      window.cart = cart;
      return cart;
    };

    const repriceUnexpectedZeroCartItems = async (cartPage, cart) => {
      if (!cart || cartPage.dataset.cleanCartZeroPriceRepairAttempted === 'true') return cart;

      const zeroPriceItems = (cart.items || []).filter(cleanCartPageHasUnexpectedZeroPrice);
      if (!zeroPriceItems.length) return cart;

      cartPage.dataset.cleanCartZeroPriceRepairAttempted = 'true';
      const updates = Object.fromEntries(
        zeroPriceItems
          .map((item) => [String(item.key || '').trim(), cleanCartPageQuantity(item.quantity)])
          .filter(([key, quantity]) => key && quantity > 0),
      );
      if (!Object.keys(updates).length) return cart;

      const response = await cleanCartPageRequest(
        cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUpdateUrl, '/cart/update'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        },
      );
      if (!response.ok) return cart;

      const repricedCart = await response.json();
      window.CleanCartState?.publish?.(repricedCart);
      window.cart = repricedCart;
      return repricedCart;
    };

    const changeCleanCartPageItem = async (cartPage, key, quantity, { signal } = {}) => {
      const cleanQuantity = cleanCartPageQuantity(quantity);

      const cartDrawer = document.querySelector('[data-clean-cart-drawer]');
      const drawerChangeItem = window.CleanCart?.changeItem;
      if (cartDrawer && typeof drawerChangeItem === 'function') {
        return drawerChangeItem(cartDrawer, key, cleanQuantity);
      }

      const response = await cleanCartPageRequest(
        cleanCartPageAjaxUrl(cartPage.dataset.cleanCartChangeUrl, '/cart/change'),
        {
          method: 'POST',
          signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: cleanQuantity }),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update cart.');
      }

      const cart = await response.json();
      window.CleanCartState?.publish?.(cart);
      document.dispatchEvent(new CustomEvent('clean:cart:updated', { detail: { cart, origin: 'clean-main-cart' } }));
      return cart;
    };

    const setCleanCartPageItemBusy = (item, isBusy) => {
      if (!item) return;
      item.toggleAttribute('aria-busy', isBusy);
      item.dataset.cleanCartPageItemBusy = isBusy ? 'true' : 'false';
      item.querySelectorAll('button, input').forEach((control) => {
        control.disabled = isBusy;
      });
    };

    const restoreCleanCartPageItemQuantity = (item) => {
      const key = item?.dataset.cleanCartPageItem;
      const currentItem = (window.cart?.items || []).find(
        (cartItem) => String(cartItem?.key || '') === String(key || ''),
      );
      const input = item?.querySelector('[data-clean-cart-page-quantity-input]');
      if (!input) return;
      input.value = currentItem ? String(currentItem.quantity || 0) : input.defaultValue;
    };

    const queueCleanCartPageMutation = (cartPage, mutationState, item, quantity) => {
      const key = item?.dataset.cleanCartPageItem;
      if (!key || item.dataset.cleanCartPageItemBusy === 'true' || mutationState.destroyed) {
        return Promise.resolve(null);
      }

      setCleanCartPageItemBusy(item, true);
      const operation = mutationState.queue.then(() =>
        changeCleanCartPageItem(cartPage, key, quantity, { signal: mutationState.signal }),
      );
      mutationState.queue = operation.catch(() => {});

      return operation.finally(() => {
        if (item.isConnected) setCleanCartPageItemBusy(item, false);
      });
    };

    const initCleanCartPage = (root = document) => {
      root.querySelectorAll('[data-clean-cart-page]').forEach((cartPage) => {
        if (cartPage.dataset.cleanCartPageReady === 'true') return;
        cartPage.dataset.cleanCartPageReady = 'true';
        const lifecycle = new AbortController();
        const mutationState = {
          destroyed: false,
          queue: Promise.resolve(),
          signal: lifecycle.signal,
        };
        cartPage.cleanCartPageLifecycle = lifecycle;
        cartPage.cleanCartPageMutationState = mutationState;
        initCleanCartPageTools(cartPage, lifecycle);
        updateCleanCartPageRewards(cartPage, {
          total_price: cleanCartPageNormalizePrice(cartPage.dataset.cleanCartTotalCents),
        });

        window.CleanGokwik.syncScope(cartPage, { detect: true, prepare: true }).catch(() => {});

        cartPage.querySelectorAll('[data-clean-gokwik-checkout]').forEach((button) => {
          button.addEventListener(
            'click',
            async (event) => {
              event.preventDefault();

              if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

              button.disabled = true;
              setCleanCartPageStatus(cartPage);

              try {
                await fetchCleanCartPage(cartPage);
                await window.CleanGokwik.checkout(button, cartPage);
              } catch (error) {
                setCleanCartPageStatus(cartPage, error?.message || 'Unable to start GoKwik checkout.');
                window.CleanGokwik.fallbackToShopify(cartPage, 'cart_refresh_failed');
              } finally {
                button.disabled = false;
              }
            },
            { signal: lifecycle.signal },
          );
        });

        cartPage.addEventListener(
          'click',
          async (event) => {
            const item = event.target.closest('[data-clean-cart-page-item]');
            if (!item || !cartPage.contains(item)) return;

            const quantityInput = item.querySelector('[data-clean-cart-page-quantity-input]');
            let quantity = null;

            if (event.target.closest('[data-clean-cart-page-remove]')) {
              quantity = 0;
            } else if (event.target.closest('[data-clean-cart-page-quantity-decrease]')) {
              quantity = cleanCartPageQuantity(quantityInput?.value) - 1;
            } else if (event.target.closest('[data-clean-cart-page-quantity-increase]')) {
              quantity = cleanCartPageQuantity(quantityInput?.value) + 1;
            }

            if (quantity === null) return;

            event.preventDefault();
            setCleanCartPageStatus(cartPage);

            try {
              await queueCleanCartPageMutation(cartPage, mutationState, item, quantity);
            } catch (error) {
              restoreCleanCartPageItemQuantity(item);
              setCleanCartPageStatus(cartPage, error?.message || 'Unable to update cart.');
            }
          },
          { signal: lifecycle.signal },
        );

        cartPage.addEventListener(
          'change',
          async (event) => {
            const input = event.target.closest('[data-clean-cart-page-quantity-input]');
            if (!input || !cartPage.contains(input)) return;

            const item = input.closest('[data-clean-cart-page-item]');
            if (!item) return;

            setCleanCartPageStatus(cartPage);

            try {
              await queueCleanCartPageMutation(cartPage, mutationState, item, input.value);
            } catch (error) {
              restoreCleanCartPageItemQuantity(item);
              setCleanCartPageStatus(cartPage, error?.message || 'Unable to update cart.');
            }
          },
          { signal: lifecycle.signal },
        );

        document.addEventListener(
          'clean:cart:updated',
          (event) => {
            if (event.detail?.cart) {
              updateCleanCartPageTools(cartPage, event.detail.cart);
              renderCleanCartPage(cartPage, event.detail.cart);
            }
          },
          { signal: lifecycle.signal },
        );

        mutationState.queue = fetchCleanCartPage(cartPage)
          .then((cart) => repriceUnexpectedZeroCartItems(cartPage, cart))
          .then((cart) => {
            updateCleanCartPageTools(cartPage, cart);
            renderCleanCartPage(cartPage, cart);
            return cart;
          })
          .catch(() => {});
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCartPage(), { once: true });
    } else {
      initCleanCartPage();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanCartPage(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.('[data-clean-cart-page]').forEach((cartPage) => {
        if (cartPage.cleanCartPageMutationState) cartPage.cleanCartPageMutationState.destroyed = true;
        cartPage.cleanCartPageLifecycle?.abort();
        delete cartPage.dataset.cleanCartPageReady;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hadiyah-delivery-localization"]) return;
  try {
    
  (() => {
    if (window.hadiyahDeliveryLocationReady) return;

    const modal = document.querySelector('[data-hadiyah-delivery-modal]');
    if (!modal) return;

    window.hadiyahDeliveryLocationReady = true;

    const storageKey = 'hadiyah:pdp-pincode';
    const cityStorageKey = 'hadiyah:pdp-pincode-city';
    const deliveryCountryCodeKey = 'hadiyah:delivery-country-code';
    const deliveryCountryNameKey = 'hadiyah:delivery-country-name';
    const defaultTitle = 'Where should we deliver?';
    const gateTitle = 'Set delivery location';
    const form = modal.querySelector('#hadiyah-delivery-localization-form');
    const input = modal.querySelector('[data-hadiyah-pincode-input]');
    const status = modal.querySelector('[data-hadiyah-delivery-status]');
    const applyButton = modal.querySelector('[data-hadiyah-delivery-apply]');
    const clearButton = modal.querySelector('[data-hadiyah-pincode-clear]');
    const removeButton = modal.querySelector('[data-hadiyah-pincode-remove]');
    const titleElement = modal.querySelector('[data-hadiyah-delivery-title]');
    const countryCodeInput = modal.querySelector('[data-hadiyah-country-code-input]');
    const countryToggle = modal.querySelector('[data-hadiyah-country-toggle]');
    const countryPicker = modal.querySelector('[data-hadiyah-country-picker]');
    const countrySearch = modal.querySelector('[data-hadiyah-country-search]');
    const countryOptions = [...modal.querySelectorAll('[data-hadiyah-country-option]')];
    const countryGroupLabels = [...modal.querySelectorAll('[data-hadiyah-country-group-label]')];
    const countryEmpty = modal.querySelector('[data-hadiyah-country-empty]');
    const locationField = modal.querySelector('[data-hadiyah-location]');
    const orSection = modal.querySelector('[data-hadiyah-delivery-or]');
    const pincodeHelpButton = modal.querySelector('[data-hadiyah-pincode-help]');
    const selectedCountryCodeElement = modal.querySelector('[data-hadiyah-selected-country-code]');
    const selectedCountryNameElement = modal.querySelector('[data-hadiyah-selected-country-name]');
    const summaryCountryElement = modal.querySelector('[data-hadiyah-summary-country]');
    const summaryFlagElement = modal.querySelector('[data-hadiyah-summary-flag]');
    const summaryChangeButton = modal.querySelector('[data-hadiyah-summary-change]');
    const countryBackButton = modal.querySelector('[data-hadiyah-country-back]');
    const returnToInput = form.elements.namedItem('return_to');
    const defaultApplyLabel = applyButton.textContent.trim() || 'Apply';
    const currentCountryCode = modal.dataset.hadiyahCurrentCountryCode || 'IN';
    const currentCountryName = modal.dataset.hadiyahCurrentCountryName || 'India';
    let selectedCountryCode = currentCountryCode;
    let selectedCountryName = currentCountryName;
    let bitset = '';
    let indexRequest;
    let opener;
    let busy = false;
    let modalOpenedThisPage = false;
    let closeTimer;
    let gateReopenTimer;
    let gateDismissedThisPage = false;
    let lockedScrollY = 0;

    const syncIndiaOnlyFields = () => {
      const isIndia = selectedCountryCode === 'IN';
      modal.classList.toggle('hadiyah-delivery-modal--international', !isIndia);

      if (orSection) {
        orSection.hidden = !isIndia;
        orSection.setAttribute('aria-hidden', String(!isIndia));
      }

      if (locationField) {
        locationField.hidden = !isIndia;
        locationField.dataset.international = String(!isIndia);
      }

      if (pincodeHelpButton && !isIndia) {
        pincodeHelpButton.hidden = true;
      }

      if (!isIndia) {
        input.value = '';
        clearButton.hidden = true;
      }
    };

    const lockPageScroll = () => {
      if (document.body.classList.contains('hadiyah-delivery-modal-open')) return;

      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('hadiyah-delivery-modal-open');
      document.body.classList.add('hadiyah-delivery-modal-open');
      document.body.style.top = `-${lockedScrollY}px`;
    };

    const unlockPageScroll = () => {
      if (!document.body.classList.contains('hadiyah-delivery-modal-open')) return;

      document.documentElement.classList.remove('hadiyah-delivery-modal-open');
      document.body.classList.remove('hadiyah-delivery-modal-open');
      document.body.style.removeProperty('top');
      window.scrollTo(0, lockedScrollY);
    };

    const setTriggerExpanded = (expanded) => {
      document.querySelectorAll('[data-hadiyah-location-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    };

    const openDeliveryDialog = (forceModal = false) => {
      if (typeof modal.showModal !== 'function') {
        modal.setAttribute('open', '');
        modal.setAttribute('aria-modal', forceModal ? 'true' : 'false');
        return;
      }

      const wantsModal = forceModal;
      const isModalOpen = modal.open && modal.matches(':modal');

      if (modal.open && isModalOpen !== wantsModal) {
        modal.close();
      }

      if (!modal.open) {
        if (wantsModal) {
          modal.showModal();
        } else {
          modal.show();
        }
      }

      modal.setAttribute('aria-modal', wantsModal ? 'true' : 'false');
    };

    const normalizePincode = (value) =>
      String(value || '')
        .replace(/\D/g, '')
        .slice(0, 6);

    const isCompletePincode = (value) => /^\d{6}$/.test(value);

    const countryDisplayCodes = {
      IN: 'IND',
      US: 'USA',
      AE: 'UAE',
      GB: 'GBR',
      CA: 'CAN',
      AU: 'AUS',
      SA: 'SAU',
    };

    const getCountryDisplayCode = (countryCode) => {
      const normalizedCode = String(countryCode || '').toUpperCase();
      return countryDisplayCodes[normalizedCode] || normalizedCode;
    };

    const countryFlagUrl = (countryCode) => {
      const normalizedCode = String(countryCode || '').toUpperCase();
      const template = modal.dataset.hadiyahCountryFlagUrlTemplate || '';
      if (!/^[A-Z]{2}$/.test(normalizedCode) || !template) return '';

      return template.replace('__country_code__', normalizedCode.toLowerCase());
    };

    const renderCountryFlag = (flag, countryCode) => {
      if (!flag) return;

      const normalizedCode = String(countryCode || '').toUpperCase();
      const source = countryFlagUrl(normalizedCode);
      flag.dataset.countryCode = normalizedCode;

      if (!source) {
        flag.textContent = normalizedCode;
        return;
      }

      const image = flag.querySelector('img') || document.createElement('img');
      image.alt = '';
      image.width = 30;
      image.height = 22;
      image.decoding = 'async';
      if (flag.matches('.hadiyah-delivery-modal__country-option-flag')) image.loading = 'lazy';
      image.addEventListener(
        'error',
        () => {
          if (image.parentElement === flag) flag.textContent = normalizedCode;
        },
        { once: true },
      );
      if (image.getAttribute('src') !== source) image.src = source;
      if (image.parentElement !== flag || flag.childElementCount !== 1) flag.replaceChildren(image);
    };

    const syncCountryFlags = (root = document) => {
      root.querySelectorAll('[data-hadiyah-country-flag]').forEach((flag) => {
        renderCountryFlag(flag, flag.dataset.countryCode);
      });
    };

    const readSavedPincode = () => {
      try {
        const pincode = normalizePincode(window.localStorage.getItem(storageKey));
        return isCompletePincode(pincode) ? pincode : '';
      } catch (error) {
        return '';
      }
    };

    const writeSavedPincode = (pincode) => {
      try {
        if (pincode) {
          const previousPincode = normalizePincode(window.localStorage.getItem(storageKey));
          window.localStorage.setItem(storageKey, pincode);
          if (previousPincode !== pincode) window.localStorage.removeItem(cityStorageKey);
        } else {
          window.localStorage.removeItem(storageKey);
          window.localStorage.removeItem(cityStorageKey);
        }
      } catch (error) {}
    };

    const readSavedCity = () => {
      try {
        return String(window.localStorage.getItem(cityStorageKey) || '').trim();
      } catch (error) {
        return '';
      }
    };

    const writeSavedCity = (city) => {
      try {
        if (city) {
          window.localStorage.setItem(cityStorageKey, city);
        } else {
          window.localStorage.removeItem(cityStorageKey);
        }
      } catch (error) {}
    };

    const readSavedDeliveryCountry = () => {
      try {
        const code = String(window.localStorage.getItem(deliveryCountryCodeKey) || '')
          .trim()
          .toUpperCase();
        if (!/^[A-Z]{2}$/.test(code)) {
          return { code: '', name: '' };
        }
        const name = String(window.localStorage.getItem(deliveryCountryNameKey) || '').trim();
        return { code, name };
      } catch (error) {
        return { code: '', name: '' };
      }
    };

    const writeSavedDeliveryCountry = (countryCode, countryName) => {
      try {
        const code = String(countryCode || '')
          .trim()
          .toUpperCase();
        if (!/^[A-Z]{2}$/.test(code)) {
          window.localStorage.removeItem(deliveryCountryCodeKey);
          window.localStorage.removeItem(deliveryCountryNameKey);
          return;
        }
        window.localStorage.setItem(deliveryCountryCodeKey, code);
        window.localStorage.setItem(
          deliveryCountryNameKey,
          String(countryName || code).trim() || code,
        );
        document.dispatchEvent(
          new CustomEvent('hadiyah:delivery-country:saved', {
            detail: { code, name: String(countryName || code).trim() || code },
          }),
        );
      } catch (error) {}
    };

    const hasDeliveryLocationSet = () => {
      const destination = readSavedDeliveryCountry();
      if (destination.code && destination.code !== 'IN') return true;
      return Boolean(readSavedPincode());
    };

    const titleCaseCity = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .replace(/\bSuburban\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim();

    const resolveCityForPincode = async (pincode) => {
      if (!isCompletePincode(pincode)) return '';

      try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
        if (!response.ok) return '';

        const payload = await response.json();
        const entry = Array.isArray(payload) ? payload[0] : payload;
        if (!entry || entry.Status !== 'Success' || !Array.isArray(entry.PostOffice) || !entry.PostOffice.length) {
          return '';
        }

        const office =
          entry.PostOffice.find((item) => String(item.DeliveryStatus || '').toLowerCase() === 'delivery') ||
          entry.PostOffice[0];

        return titleCaseCity(office.District || office.Block || office.Division || office.Name || '');
      } catch (error) {
        return '';
      }
    };

    const ensureCityForPincode = async (pincode) => {
      if (!isCompletePincode(pincode)) {
        writeSavedCity('');
        return '';
      }

      const cachedCity = readSavedCity();
      if (cachedCity) return cachedCity;

      const city = await resolveCityForPincode(pincode);
      if (city) writeSavedCity(city);
      return city;
    };

    const enrichSavedCity = (pincode) => {
      ensureCityForPincode(pincode)
        .then((city) => {
          // The postal API is optional enrichment. Do not overwrite the UI if the
          // customer changed their delivery location while the request was running.
          if (!city || readSavedPincode() !== pincode) return;
          syncTriggers(pincode);
        })
        .catch(() => {});
    };

    const homeGateEnabled =
      modal.dataset.hadiyahHomeGate === 'true' ||
      document.body.classList.contains('template-index') ||
      window.location.pathname === '/' ||
      window.location.pathname === '';

    // Homepage gate is about delivery destination, not currency.
    // India needs a pincode; other destinations unlock browsing without switching ₹.
    const isGateLocked = () => homeGateEnabled && !hasDeliveryLocationSet();

    const getGateAnchor = (preferred) =>
      preferred ||
      document.querySelector('.hadiyah-delivery-header-slot [data-hadiyah-location-trigger]') ||
      document.querySelector('.mobile-delivery-row [data-hadiyah-location-trigger]') ||
      document.querySelector('[data-hadiyah-location-trigger]');

    const isMobileSheet = () => window.matchMedia('(max-width: 768px)').matches;

    const clearPopoverPosition = () => {
      modal.classList.remove('hadiyah-delivery-modal--popover');
      modal.classList.remove('hadiyah-delivery-modal--sheet');
      [
        'position',
        'inset',
        'top',
        'left',
        'right',
        'bottom',
        'margin',
        'transform',
        'width',
        'maxWidth',
        'maxHeight',
        'borderRadius',
      ].forEach((prop) => {
        modal.style.removeProperty(prop);
      });
      modal.style.removeProperty('--hadiyah-gate-top');
      modal.style.removeProperty('--hadiyah-gate-left');
      modal.style.removeProperty('--hadiyah-gate-caret');
    };

    const positionMobileSheet = () => {
      modal.classList.add('hadiyah-delivery-modal--popover');
      modal.classList.add('hadiyah-delivery-modal--sheet');
      modal.style.setProperty('position', 'fixed', 'important');
      modal.style.setProperty('inset', 'auto 0 0 0', 'important');
      modal.style.setProperty('top', 'auto', 'important');
      modal.style.setProperty('left', '0', 'important');
      modal.style.setProperty('right', '0', 'important');
      modal.style.setProperty('bottom', '0', 'important');
      modal.style.setProperty('margin', '0', 'important');
      modal.style.setProperty('transform', 'none', 'important');
      modal.style.setProperty('width', '100%', 'important');
      modal.style.setProperty('max-width', '100%', 'important');
      modal.style.setProperty('max-height', 'min(85dvh, 560px)', 'important');
      modal.style.setProperty('border-radius', '16px 16px 0 0', 'important');
      modal.style.removeProperty('--hadiyah-gate-top');
      modal.style.removeProperty('--hadiyah-gate-left');
      modal.style.removeProperty('--hadiyah-gate-caret');
      return true;
    };

    const positionGatePopover = (preferredAnchor) => {
      if (isMobileSheet()) {
        return positionMobileSheet();
      }

      modal.classList.remove('hadiyah-delivery-modal--sheet');

      const anchor = getGateAnchor(preferredAnchor);
      if (!anchor) {
        clearPopoverPosition();
        return false;
      }

      const panelWidth = Math.min(420, window.innerWidth - 24);
      const rect = anchor.getBoundingClientRect();
      let top = Math.round(rect.bottom + 12);
      let left = Math.round(rect.left);

      if (left + panelWidth > window.innerWidth - 12) {
        left = Math.max(12, Math.round(window.innerWidth - panelWidth - 12));
      }
      if (left < 12) left = 12;

      let caret = Math.round(rect.left + rect.width / 2 - left);
      caret = Math.max(18, Math.min(panelWidth - 18, caret));

      modal.classList.add('hadiyah-delivery-modal--popover');
      modal.style.setProperty('position', 'fixed', 'important');
      modal.style.setProperty('inset', 'unset', 'important');
      modal.style.setProperty('top', `${top}px`, 'important');
      modal.style.setProperty('left', `${left}px`, 'important');
      modal.style.setProperty('right', 'auto', 'important');
      modal.style.setProperty('bottom', 'auto', 'important');
      modal.style.setProperty('margin', '0', 'important');
      modal.style.setProperty('transform', 'none', 'important');
      modal.style.setProperty('width', `${panelWidth}px`, 'important');
      modal.style.setProperty('max-width', 'calc(100vw - 24px)', 'important');
      modal.style.removeProperty('border-radius');
      modal.style.setProperty('--hadiyah-gate-top', `${top}px`);
      modal.style.setProperty('--hadiyah-gate-left', `${left}px`);
      modal.style.setProperty('--hadiyah-gate-caret', `${caret}px`);
      return true;
    };

    const syncGateMode = (preferredAnchor) => {
      const locked = isGateLocked();
      modal.classList.toggle('hadiyah-delivery-modal--gate', locked);
      if (titleElement) {
        titleElement.textContent = locked || modal.classList.contains('hadiyah-delivery-modal--popover')
          ? gateTitle
          : defaultTitle;
      }
      positionGatePopover(preferredAnchor);
      if (titleElement && modal.classList.contains('hadiyah-delivery-modal--popover')) {
        titleElement.textContent = gateTitle;
      }
      return locked;
    };

    const preserveAutoLocationCurrency = () => {
      // Seed Auto Location from the current market BEFORE localization changes country,
      // so India visitors keep INR display after switching delivery to USA/etc.
      if (typeof window.HadiyahDisplayCurrency?.ensureAutoLocationSeed === 'function') {
        window.HadiyahDisplayCurrency.ensureAutoLocationSeed();
      }

      try {
        window.localStorage.removeItem('hadiyah_display_currency');
        window.localStorage.removeItem('hadiyah_display_country');
      } catch (error) {}

      if (typeof window.HadiyahDisplayCurrency?.useAutoLocation === 'function') {
        window.HadiyahDisplayCurrency.useAutoLocation();
        return;
      }

      document.querySelector('[data-display-currency-auto]')?.click();
    };

    const resolveDeliveryDisplay = (pincode = readSavedPincode()) => {
      const savedDestination = readSavedDeliveryCountry();
      const code = savedDestination.code || currentCountryCode;
      const option = countryOptions.find((item) => item.dataset.countryCode === code);
      const name = savedDestination.name || option?.dataset.countryName || currentCountryName;
      return { code, name, pincode };
    };

    const submitLocalizationForm = () => {
      const isLocalPreview = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

      if (isLocalPreview) {
        const localizationUrl = new URL(modal.dataset.hadiyahLocalizationUrl);
        const returnToUrl = new URL(window.location.href);
        const previewThemeId = String(window.Shopify?.theme?.id || '');

        if (localizationUrl.protocol === 'https:') form.action = localizationUrl.href;

        if (returnToInput instanceof HTMLInputElement) {
          if (/^\d+$/.test(previewThemeId)) returnToUrl.searchParams.set('preview_theme_id', previewThemeId);
          returnToInput.value = `${returnToUrl.pathname}${returnToUrl.search}`;
        }
      }

      HTMLFormElement.prototype.submit.call(form);
    };

    const syncTriggers = (pincode = readSavedPincode()) => {
      const display = resolveDeliveryDisplay(pincode);
      const isIndia = display.code === 'IN';
      const savedCity = readSavedCity();

      document.querySelectorAll('[data-hadiyah-delivery-summary-country]').forEach((el) => {
        el.textContent = display.name;
      });

      document
        .querySelectorAll(
          '[data-hadiyah-delivery-summary] [data-hadiyah-country-flag], .hadiyah-delivery__summary-flag[data-hadiyah-country-flag]',
        )
        .forEach((flag) => {
          renderCountryFlag(flag, display.code);
        });

      // Also refresh any PDP picker summary UI that manages its own flag rendering.
      document.querySelectorAll('hadiyah-delivery-picker').forEach((picker) => {
        if (typeof picker.syncSummaryLocation === 'function') picker.syncSummaryLocation();
        else if (typeof picker.renderSummaryFlag === 'function') picker.renderSummaryFlag(display.code);
      });

      document.querySelectorAll('[data-hadiyah-location-trigger]').forEach((trigger) => {
        const hasLocation = true;
        const isMobileTrigger = trigger.dataset.hadiyahTriggerVariant === 'mobile';
        const isProductTrigger = trigger.dataset.hadiyahTriggerVariant === 'product';
        const isPickerCountryTrigger = trigger.dataset.hadiyahTriggerVariant === 'picker-country';
        const isPickerSummaryTrigger = trigger.dataset.hadiyahTriggerVariant === 'picker-summary';
        let deliveryValue = display.name;
        let productLabel = display.name;

        if (isIndia) {
          if (display.pincode) {
            productLabel = savedCity ? `${savedCity} ${display.pincode}` : display.pincode;
            // Header / mobile pill: "Delivering to 400008" (pincode only).
            deliveryValue = display.pincode;
          } else {
            productLabel = 'Add pincode';
          }
        }

        const flag = trigger.querySelector('[data-hadiyah-country-flag]');
        const prompt = trigger.querySelector('[data-hadiyah-delivery-prompt]');
        const saved = trigger.querySelector('[data-hadiyah-delivery-saved]');
        const value = trigger.querySelector('[data-hadiyah-delivery-value]');
        const code = trigger.querySelector('[data-hadiyah-delivery-code]');

        renderCountryFlag(flag, display.code);

        if (code) {
          if (isPickerCountryTrigger) {
            code.textContent = getCountryDisplayCode(display.code);
          } else {
            code.textContent = isProductTrigger ? productLabel : getCountryDisplayCode(display.code);
          }
          code.dataset.countryCode = display.code;
        }

        if (prompt) prompt.hidden = hasLocation;
        if (saved) saved.hidden = !hasLocation;
        if (value) value.textContent = isProductTrigger ? productLabel : deliveryValue;

        const ariaLabel = isPickerSummaryTrigger || isPickerCountryTrigger
          ? display.name
          : isProductTrigger
            ? productLabel
            : deliveryValue;
        trigger.dataset.hasLocation = String(hasLocation);
        trigger.setAttribute(
          'aria-label',
          hasLocation ? `Delivery location ${ariaLabel}. Change delivery location.` : 'Choose delivery location',
        );

        if (isIndia && trigger.dataset.hadiyahIndexPrefetchReady !== 'true') {
          trigger.dataset.hadiyahIndexPrefetchReady = 'true';
          trigger.addEventListener('pointerenter', () => loadIndex().catch(() => {}), {
            once: true,
            passive: true,
          });
          trigger.addEventListener('focus', () => loadIndex().catch(() => {}), { once: true });
        }
      });
    };

    const setStatus = (message = '', type = '') => {
      status.textContent = message;
      status.classList.toggle('hadiyah-delivery-modal__status--error', type === 'error');
      status.classList.toggle('hadiyah-delivery-modal__status--success', type === 'success');
    };

    const closeCountryPicker = ({ restoreFocus = false } = {}) => {
      countryPicker.hidden = true;
      modal.classList.remove('hadiyah-delivery-modal--picking-country');
      countryToggle.setAttribute('aria-expanded', 'false');
      countrySearch.value = '';
      countryOptions.forEach((option) => {
        option.hidden = false;
      });
      countryGroupLabels.forEach((label) => {
        label.hidden = false;
      });
      countryEmpty.hidden = true;
      if (restoreFocus) {
        if (summaryChangeButton) summaryChangeButton.focus();
        else countryToggle.focus();
      }
    };

    const setCountryPickerOpen = (open) => {
      if (!open) {
        closeCountryPicker();
        return;
      }

      countryPicker.hidden = false;
      modal.classList.add('hadiyah-delivery-modal--picking-country');
      countryToggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => countrySearch.focus());
    };

    const updateControls = () => {
      const pincode = normalizePincode(input.value);
      if (input.value !== pincode) input.value = pincode;

      const isIndia = selectedCountryCode === 'IN';
      const revealApplyOnValid =
        modal.classList.contains('hadiyah-delivery-modal--popover') ||
        modal.classList.contains('hadiyah-delivery-modal--gate');

      input.disabled = busy || !isIndia;
      clearButton.hidden = !isIndia || !pincode;
      removeButton.hidden = !isIndia || !readSavedPincode();
      applyButton.hidden = false;

      if (!revealApplyOnValid) {
        applyButton.disabled = busy || (isIndia && Boolean(pincode) && !isCompletePincode(pincode));
        return;
      }

      if (!isIndia) {
        // International: Apply is always available (no Indian pincode required).
        applyButton.disabled = busy;
        return;
      }

      if (!isCompletePincode(pincode) || busy) {
        applyButton.disabled = true;
        return;
      }

      applyButton.disabled = true;

      loadIndex()
        .then(() => {
          if (normalizePincode(input.value) !== pincode) return;

          const valid = isKnownPincode(pincode);
          applyButton.disabled = busy || !valid;

          if (!valid) {
            setStatus('Enter a valid Indian pincode.', 'error');
          } else if (status.classList.contains('hadiyah-delivery-modal__status--error')) {
            setStatus();
          }
        })
        .catch(() => {
          if (normalizePincode(input.value) !== pincode) return;
          applyButton.disabled = true;
          setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
        });
    };

    const selectCountry = (countryCode, countryName, { closePicker = true, prefetchIndex = true } = {}) => {
      selectedCountryCode = countryCode;
      selectedCountryName = countryName;
      countryCodeInput.value = countryCode;
      selectedCountryCodeElement.textContent = countryCode;
      selectedCountryNameElement.textContent = countryName;
      if (summaryCountryElement) summaryCountryElement.textContent = countryName;

      const selectedFlag = countryToggle.querySelector('[data-hadiyah-country-flag]');
      renderCountryFlag(selectedFlag, countryCode);
      renderCountryFlag(summaryFlagElement, countryCode);

      countryOptions.forEach((option) => {
        option.setAttribute('aria-selected', String(option.dataset.countryCode === countryCode));
      });

      syncIndiaOnlyFields();

      if (countryCode === 'IN') {
        input.value = readSavedPincode();
        if (prefetchIndex) {
          loadIndex().catch(() => {
            setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
          });
        }
      } else {
        setStatus();
      }

      if (closePicker) closeCountryPicker();
      updateControls();
    };

    const setBusy = (nextBusy) => {
      busy = nextBusy;
      clearButton.disabled = busy;
      removeButton.disabled = busy;
      countryToggle.disabled = busy;
      countrySearch.disabled = busy;
      countryOptions.forEach((option) => {
        option.disabled = busy;
      });
      applyButton.textContent = busy ? 'Applying...' : defaultApplyLabel;
      updateControls();
    };

    const consumeIndex = () => {
      const payload = window.HadiyahPincodeIndex;

      if (!payload || payload.version !== 1 || payload.bitCount !== 1_000_000 || typeof payload.data !== 'string') {
        throw new Error('The pincode index payload is invalid.');
      }

      bitset = window.atob(payload.data);
      if (bitset.length * 8 !== payload.bitCount) {
        bitset = '';
        throw new Error('The pincode index size is invalid.');
      }

      window.HadiyahPincodeIndex = undefined;
      return bitset;
    };

    const loadIndex = () => {
      if (bitset) return Promise.resolve(bitset);
      if (indexRequest) return indexRequest;

      if (window.HadiyahPincodeIndex) {
        try {
          return Promise.resolve(consumeIndex());
        } catch (error) {
          window.HadiyahPincodeIndex = undefined;
        }
      }

      indexRequest = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = modal.dataset.hadiyahPincodeIndexUrl;
        script.async = true;
        script.dataset.hadiyahPincodeIndexLoader = 'true';
        script.addEventListener(
          'load',
          () => {
            try {
              resolve(consumeIndex());
            } catch (error) {
              reject(error);
            }
          },
          { once: true },
        );
        script.addEventListener('error', () => reject(new Error('The pincode index could not be loaded.')), {
          once: true,
        });
        document.head.append(script);
      }).catch((error) => {
        indexRequest = undefined;
        document.querySelector('[data-hadiyah-pincode-index-loader]')?.remove();
        throw error;
      });

      return indexRequest;
    };

    const isKnownPincode = (pincode) => {
      if (!bitset || !isCompletePincode(pincode)) return false;

      const numericPincode = Number(pincode);
      const byte = bitset.charCodeAt(numericPincode >> 3);
      return Boolean(byte & (1 << (numericPincode & 7)));
    };

    const dispatchSavedPincode = (pincode) => {
      document.dispatchEvent(
        new CustomEvent('hadiyah:pincode:saved', {
          detail: { pincode, source: 'delivery-location' },
        }),
      );

      document.querySelectorAll('[data-hadiyah-delivery-postcode-input]').forEach((pickerInput) => {
        pickerInput.value = pincode;
        pickerInput.dispatchEvent(new Event('input', { bubbles: true }));

        if (pincode) {
          pickerInput
            .closest('hadiyah-delivery-picker')
            ?.querySelector('[data-hadiyah-delivery-postcode-check]')
            ?.click();
        }
      });
    };

    const closeModal = ({ force = false } = {}) => {
      window.clearTimeout(closeTimer);
      window.clearTimeout(gateReopenTimer);
      closeCountryPicker();

      // Homepage gate can be dismissed; users can reopen from the header trigger anytime.
      if (isGateLocked()) {
        gateDismissedThisPage = true;
      }

      syncGateMode();
      setTriggerExpanded(false);
      unlockPageScroll();

      if (typeof modal.close === 'function') {
        if (modal.open) modal.close();
      } else {
        modal.removeAttribute('open');
        opener?.focus();
      }
    };

    const openModal = (trigger, { prefetchIndex = true, focusInput = true } = {}) => {
      window.clearTimeout(closeTimer);
      window.clearTimeout(gateReopenTimer);
      modalOpenedThisPage = true;
      gateDismissedThisPage = false;
      opener = trigger;
      input.value = readSavedPincode();
      setStatus();
      const locked = syncGateMode(trigger);
      const savedDestination = readSavedDeliveryCountry();
      const openCountryCode = savedDestination.code || (locked ? 'IN' : currentCountryCode);
      const openCountryOption = countryOptions.find((option) => option.dataset.countryCode === openCountryCode);
      const openCountryName =
        savedDestination.name ||
        openCountryOption?.dataset.countryName ||
        (openCountryCode === 'IN' ? 'India' : currentCountryName);
      selectCountry(openCountryCode, openCountryName, {
        prefetchIndex: openCountryCode === 'IN' && (locked || prefetchIndex),
      });
      setBusy(false);

      openDeliveryDialog(locked);
      setTriggerExpanded(true);

      if (locked) {
        lockPageScroll();
      } else {
        unlockPageScroll();
      }

      positionGatePopover(trigger);
      window.requestAnimationFrame(() => positionGatePopover(trigger));

      if (focusInput) {
        window.requestAnimationFrame(() => {
          if (selectedCountryCode === 'IN' || locked) {
            input.focus();
            input.select();
          } else {
            countryToggle.focus();
          }
        });
      }
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-hadiyah-location-trigger]');
      if (trigger) {
        if (modal.open && opener === trigger) {
          closeModal({ force: true });
          return;
        }
        openModal(trigger);
        return;
      }

      if (event.target.closest('[data-hadiyah-delivery-close]')) {
        closeModal({ force: true });
        return;
      }

      const countryOption = event.target.closest('[data-hadiyah-country-option]');
      if (countryOption) {
        selectCountry(countryOption.dataset.countryCode, countryOption.dataset.countryName);
        return;
      }

      if (event.target.closest('[data-hadiyah-delivery-postcode-check]')) {
        syncTriggers();
      }

      if (
        modal.open &&
        !modal.contains(event.target) &&
        !event.target.closest('[data-hadiyah-location-trigger]')
      ) {
        closeModal({ force: true });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('[data-hadiyah-delivery-postcode-input]')) {
        window.setTimeout(() => syncTriggers());
      }
    });

    countryToggle.addEventListener('click', (event) => {
      // Keep this click from the modal outside-click handler (below).
      event.stopPropagation();
      setCountryPickerOpen(countryPicker.hidden);
    });

    summaryChangeButton?.addEventListener('click', (event) => {
      // Change used to open the list then the same bubbled click closed it immediately.
      event.preventDefault();
      event.stopPropagation();
      setCountryPickerOpen(true);
      window.requestAnimationFrame(() => {
        countrySearch?.focus();
        countryPicker.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
      });
    });

    countryBackButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeCountryPicker({ restoreFocus: true });
    });

    countrySearch.addEventListener('input', () => {
      const query = countrySearch.value.trim().toLocaleLowerCase();
      let visibleOptions = 0;

      countryOptions.forEach((option) => {
        const searchableValue =
          `${option.dataset.countryName} ${option.dataset.countryCode} ${option.dataset.currencyCode}`.toLocaleLowerCase();
        option.hidden = Boolean(query) && !searchableValue.includes(query);
        if (!option.hidden) visibleOptions += 1;
      });

      countryGroupLabels.forEach((label) => {
        label.hidden = Boolean(query);
      });
      countryEmpty.hidden = visibleOptions !== 0;
    });

    input.addEventListener('input', () => {
      input.value = normalizePincode(input.value);
      setStatus();
      updateControls();
    });

    clearButton.addEventListener('click', () => {
      input.value = '';
      setStatus();
      updateControls();
      input.focus();
    });

    removeButton.addEventListener('click', () => {
      writeSavedPincode('');
      input.value = '';
      syncTriggers('');
      dispatchSavedPincode('');
      syncGateMode();
      setStatus('Saved pincode removed.', 'success');
      updateControls();
      input.focus();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const gateLocked = isGateLocked();

      countryCodeInput.value = selectedCountryCode;
      writeSavedDeliveryCountry(selectedCountryCode, selectedCountryName);

      if (selectedCountryCode !== 'IN') {
        writeSavedPincode('');
        writeSavedCity('');
        dispatchSavedPincode('');
        // Market prices follow delivery country; Bucks stays on Auto Location (e.g. INR).
        preserveAutoLocationCurrency();
        syncGateMode();

        if (selectedCountryCode !== currentCountryCode) {
          setBusy(true);
          setStatus(`Updating prices for delivery to ${selectedCountryName}...`);
          submitLocalizationForm();
          return;
        }

        syncTriggers('');
        setStatus(`Delivery set to ${selectedCountryName}.`, 'success');
        closeTimer = window.setTimeout(() => closeModal({ force: true }), 350);
        return;
      }

      const pincode = normalizePincode(input.value);

      if (!pincode) {
        if (gateLocked) {
          setStatus('Enter a valid Indian pincode to continue.', 'error');
          input.focus();
          return;
        }

        writeSavedPincode('');
        writeSavedCity('');
        dispatchSavedPincode('');
        preserveAutoLocationCurrency();
        syncGateMode();

        if (selectedCountryCode !== currentCountryCode) {
          setBusy(true);
          setStatus('Updating prices for delivery within India...');
          submitLocalizationForm();
          return;
        }

        syncTriggers('');
        setStatus('Delivery country set to India.', 'success');
        closeTimer = window.setTimeout(() => closeModal({ force: true }), 350);
        return;
      }

      if (!isCompletePincode(pincode)) {
        setStatus('Enter a six-digit Indian pincode.', 'error');
        updateControls();
        input.focus();
        return;
      }

      setBusy(true);
      setStatus('Checking pincode...');

      try {
        await loadIndex();

        if (!isKnownPincode(pincode)) {
          setStatus('Enter a valid Indian pincode.', 'error');
          return;
        }

        writeSavedPincode(pincode);
        dispatchSavedPincode(pincode);
        const city = readSavedCity();
        writeSavedDeliveryCountry('IN', 'India');
        preserveAutoLocationCurrency();
        syncGateMode();

        if (selectedCountryCode !== currentCountryCode) {
          setStatus('Updating prices for delivery within India...');
          submitLocalizationForm();
          return;
        }

        syncTriggers(pincode);
        setStatus(
          city ? `Delivery location set to ${city} ${pincode}.` : `Delivery location set to ${pincode}.`,
          'success',
        );
        enrichSavedCity(pincode);
        closeTimer = window.setTimeout(() => closeModal({ force: true }), 450);
      } catch (error) {
        setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
      } finally {
        setBusy(false);
      }
    });

    modal.addEventListener('click', (event) => {
      const clickedChange = event.target.closest?.('[data-hadiyah-summary-change]');
      if (
        !countryPicker.hidden &&
        !countryPicker.contains(event.target) &&
        !countryToggle.contains(event.target) &&
        !clickedChange
      ) {
        closeCountryPicker();
      }

      if (event.target === modal) closeModal();
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !countryPicker.hidden) {
        event.preventDefault();
        event.stopPropagation();
        closeCountryPicker({ restoreFocus: true });
      }
    });

    modal.addEventListener('cancel', (event) => {
      if (!countryPicker.hidden) {
        event.preventDefault();
        closeCountryPicker({ restoreFocus: true });
        return;
      }

      // Allow Escape to dismiss the homepage gate.
      gateDismissedThisPage = true;
      unlockPageScroll();
    });

    modal.addEventListener('close', () => {
      setTriggerExpanded(false);
      window.clearTimeout(gateReopenTimer);
      unlockPageScroll();
      setStatus();
      opener?.focus();
      clearPopoverPosition();
      syncGateMode();
    });

    window.addEventListener('pageshow', () => {
      syncTriggers();
      syncGateMode();
    });
    window.addEventListener('resize', () => {
      if (modal.open) positionGatePopover(opener);
    });
    window.addEventListener(
      'scroll',
      () => {
        if (modal.open) positionGatePopover(opener);
      },
      true,
    );
    window.addEventListener('storage', (event) => {
      if (
        event.key === storageKey ||
        event.key === deliveryCountryCodeKey ||
        event.key === deliveryCountryNameKey ||
        event.key === cityStorageKey
      ) {
        syncTriggers();
        syncGateMode();
      }
    });

    document.addEventListener('shopify:section:load', () => {
      syncTriggers();
      syncGateMode();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        window.requestAnimationFrame(() => syncTriggers());
      });
    }

    syncCountryFlags();
    syncTriggers();
    syncGateMode();

    const savedDestinationOnBoot = readSavedDeliveryCountry();
    if (savedDestinationOnBoot.code) {
      selectedCountryCode = savedDestinationOnBoot.code;
      selectedCountryName = savedDestinationOnBoot.name || savedDestinationOnBoot.code;
    }
    syncIndiaOnlyFields();

    const initialPincode = readSavedPincode();
    if (initialPincode && !readSavedCity()) {
      enrichSavedCity(initialPincode);
    }

    const openHomeGateWhenReady = () => {
      if (!isGateLocked() || gateDismissedThisPage) return;

      const revealGate = () => {
        if (!isGateLocked() || gateDismissedThisPage || document.hidden || modal.open || modalOpenedThisPage) {
          return;
        }
        openModal(getGateAnchor() || undefined, { prefetchIndex: true, focusInput: true });
      };

      const scheduleReveal = () => {
        window.setTimeout(() => {
          if ('requestAnimationFrame' in window) {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(revealGate);
            });
          } else {
            revealGate();
          }
        }, 700);
      };

      if (document.readyState === 'complete') {
        scheduleReveal();
      } else {
        window.addEventListener('load', scheduleReveal, { once: true });
      }
    };

    openHomeGateWhenReady();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
